import React, { useEffect, useState } from "react";
import { DataGrid, GridToolbarQuickFilter } from "@mui/x-data-grid";
import axios from "axios";
import {
  Box,
  Typography,
  Button,
  TextField,
  Modal,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Autocomplete,
  Chip,
  Paper,
  IconButton,
  Tooltip,
  Card,
  CardContent,
  Grid,
  Avatar,
  Fade,
  Backdrop,
  FormHelperText,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  ToggleButton,
  ToggleButtonGroup,
  Divider,
  Alert,
  Snackbar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from "@mui/icons-material/Search";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import PersonIcon from "@mui/icons-material/Person";
import BusinessIcon from "@mui/icons-material/Business";
import BadgeIcon from "@mui/icons-material/Badge";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import EventIcon from "@mui/icons-material/Event";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import LockIcon from "@mui/icons-material/Lock";
import WorkIcon from "@mui/icons-material/Work";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

import Topbar from "../../topbar/Topbar";
import Sidebar from "../../sidebar/Sidebar";
import EFClogo from "../../Images/Bmpower_Logo/BMP - EFC.jpg";

// ═════════════════════════════════════════════════════════════════════════════
// 1. CONSTANTS & CONFIGURATION
// ═════════════════════════════════════════════════════════════════════════════

export const OUTLET_DATA = [
  {
    id: 1,
    region: "NCR",
    outlet: "AFPCES - BNS C&X NAVAL GATE 3 FORT BONIFACIO",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "AFPCES",
    payrollAccount: "BALANCE",
  },
  {
    id: 2,
    region: "NCR",
    outlet: "AFPCES - FB C&X FORT BONIFACIO",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "AFPCES",
    payrollAccount: "BALANCE",
  },
  {
    id: 3,
    region: "NCR",
    outlet: "AFPCES CAMP AGUINALDO",
    accountSupervisor: "CASERES, JAYSON",
    adp: "AFPCES",
    payrollAccount: "BALANCE",
  },
  {
    id: 4,
    region: "NCR",
    outlet: "AFPCES MALACANANG",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "AFPCES",
    payrollAccount: "BALANCE",
  },
  {
    id: 5,
    region: "NCR",
    outlet: "AFPCES V. LUNA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "AFPCES",
    payrollAccount: "BALANCE",
  },
  {
    id: 6,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC - GAGALANGIN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 7,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC - SANTOLAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 8,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC - YUSECO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 9,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - 10TH AVE.",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 10,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - 11TH AVE.",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 11,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - 4TH STATE",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 12,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - ARLEGUI QUIAPO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 13,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - BAESA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 14,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - BAGBAG",
    accountSupervisor: "CASERES, JAYSON",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 15,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - BAGONG SILANG",
    accountSupervisor: "CASERES, JAYSON",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 16,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - BAGUMBAYAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 17,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - BAGUMBONG",
    accountSupervisor: "CASERES, JAYSON",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 18,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - BANGKAL",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 19,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - CAINTA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 20,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - CATMON",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 21,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - COMMONWEALTH",
    accountSupervisor: "CASERES, JAYSON",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 22,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - CONCEPCION",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 23,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - DALANDANAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 24,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - FOREST HILL",
    accountSupervisor: "CASERES, JAYSON",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 25,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - GEN.T DE LEON",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 26,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - HERMOSA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 27,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - KAYBIGA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 28,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - LANGARAY",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 29,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - LORETO MORNING BREEZE",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 30,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - MALIGAYA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 31,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - MARULAS",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 32,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - MASANGKAY",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 33,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - MAYPAJO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 34,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - MAYSAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 35,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - METRO PLAZA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 36,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - NAVOTAS",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 37,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - PACO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 38,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - PANDACAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 39,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - PANGHULO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 40,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - PARANG",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 41,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - PATEROS",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 42,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - PEARL DRIVE",
    accountSupervisor: "CASERES, JAYSON",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 43,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - PEÑAFRANCIA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 44,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - PINAGBUHATAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 45,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - POLO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 46,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - QUIRINO HIWAY",
    accountSupervisor: "CASERES, JAYSON",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 47,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - RETIRO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 48,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - ROCES",
    accountSupervisor: "CASERES, JAYSON",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 49,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - SAN MATEO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 50,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - SAUYO",
    accountSupervisor: "CASERES, JAYSON",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 51,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - SUCAT",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 52,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - TALIPAPA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 53,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - TONDO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 54,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - TRABAJO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 55,
    region: "NCR",
    outlet: "EVERPLUS SUPERSTORE INC. - VICAS",
    accountSupervisor: "CASERES, JAYSON",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 56,
    region: "NCR",
    outlet: "FISHERMALL MALABON",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "FISHERMALL",
    payrollAccount: "BALANCE",
  },
  {
    id: 57,
    region: "NCR",
    outlet: "FISHERMALL Q. AVENUE",
    accountSupervisor: "CASERES, JAYSON",
    adp: "FISHERMALL",
    payrollAccount: "BALANCE",
  },
  {
    id: 58,
    region: "NCR",
    outlet: "HI-TOP SUPERMARKET - AURORA BLVD",
    accountSupervisor: "CASERES, JAYSON",
    adp: "MAGIS Q.C",
    payrollAccount: "GENTRADE",
  },
  {
    id: 59,
    region: "NCR",
    outlet: "HI-TOP SUPERMARKET - Q.AVE.",
    accountSupervisor: "CASERES, JAYSON",
    adp: "GENTRADE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 60,
    region: "NCR",
    outlet: "ISETANN – CARRIEDO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ISETANN",
    payrollAccount: "BALANCE",
  },
  {
    id: 61,
    region: "NCR",
    outlet: "ISETANN – CUBAO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ISETANN",
    payrollAccount: "BALANCE",
  },
  {
    id: 62,
    region: "NCR",
    outlet: "ISETANN – STA.MESA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ISETANN",
    payrollAccount: "BALANCE",
  },
  {
    id: 63,
    region: "NCR",
    outlet: "ISETANN- RECTO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ISETANN",
    payrollAccount: "BALANCE",
  },
  {
    id: 64,
    region: "NCR",
    outlet: "LANDMARK - ALABANG",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "LANDMARK",
    payrollAccount: "BALANCE",
  },
  {
    id: 65,
    region: "NCR",
    outlet: "LANDMARK - BGC",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "LANDMARK",
    payrollAccount: "BALANCE",
  },
  {
    id: 66,
    region: "NCR",
    outlet: "LANDMARK - MAKATI-1",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "LANDMARK",
    payrollAccount: "BALANCE",
  },
  {
    id: 67,
    region: "NCR",
    outlet: "LANDMARK - MAKATI-2",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "LANDMARK",
    payrollAccount: "BALANCE",
  },
  {
    id: 68,
    region: "NCR",
    outlet: "LANDMARK - MANILA BAY",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "LANDMARK",
    payrollAccount: "BALANCE",
  },
  {
    id: 69,
    region: "NCR",
    outlet: "LANDMARK - TRINOMA COMPLEX",
    accountSupervisor: "CASERES, JAYSON",
    adp: "LANDMARK",
    payrollAccount: "BALANCE",
  },
  {
    id: 70,
    region: "NCR",
    outlet: "LANDMARK - TRINOMA MAIN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "LANDMARK",
    payrollAccount: "BALANCE",
  },
  {
    id: 71,
    region: "NCR",
    outlet: "LIANA'S SUPERMARKET - ALABANG",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "LIANAS",
    payrollAccount: "BALANCE",
  },
  {
    id: 72,
    region: "NCR",
    outlet: "LIANA'S SUPERMARKET - LEVERIZA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "LIANAS",
    payrollAccount: "BALANCE",
  },
  {
    id: 73,
    region: "NCR",
    outlet: "LIANA'S SUPERMARKET - LRT",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "LIANAS",
    payrollAccount: "BALANCE",
  },
  {
    id: 74,
    region: "NCR",
    outlet: "LIANA'S SUPERMARKET - PASIG",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "LIANAS",
    payrollAccount: "BALANCE",
  },
  {
    id: 75,
    region: "NCR",
    outlet: "LIANA'S SUPERMARKET - SAMPALOC",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "LIANAS",
    payrollAccount: "BALANCE",
  },
  {
    id: 76,
    region: "NCR",
    outlet: "LIANAS SUPERMARKET - EVACOM",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "LIANAS",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 77,
    region: "NCR",
    outlet: "MAKATI SUP. - ALABANG",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "NG CHAIN",
    payrollAccount: "BALANCE",
  },
  {
    id: 78,
    region: "NCR",
    outlet: "METRO RETAILS STORES GROUP, INC. - ALABANG",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "METRO RETAILS",
    payrollAccount: "BALANCE",
  },
  {
    id: 79,
    region: "NCR",
    outlet: "METRO RETAILS STORES GROUP, INC. - ANTIPOLO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "METRO RETAILS",
    payrollAccount: "BALANCE",
  },
  {
    id: 80,
    region: "NCR",
    outlet: "METRO RETAILS STORES GROUP, INC. - BINONDO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "METRO RETAILS",
    payrollAccount: "BALANCE",
  },
  {
    id: 81,
    region: "NCR",
    outlet: "METRO RETAILS STORES GROUP, INC. - FELIZ",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "METRO RETAILS",
    payrollAccount: "BALANCE",
  },
  {
    id: 82,
    region: "NCR",
    outlet: "METRO RETAILS STORES GROUP, INC. - GATE3",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "METRO RETAILS",
    payrollAccount: "BALANCE",
  },
  {
    id: 83,
    region: "NCR",
    outlet: "METRO RETAILS STORES GROUP, INC. - MARKET MARKET",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "METRO RETAILS",
    payrollAccount: "BALANCE",
  },
  {
    id: 84,
    region: "NCR",
    outlet: "METRO RETAILS STORES GROUP, INC. - MARKET MARKET -2",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "METRO RETAILS",
    payrollAccount: "BALANCE",
  },
  {
    id: 85,
    region: "NCR",
    outlet: "METRO RETAILS STORES GROUP, INC. - NEW PORT",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "METRO RETAILS",
    payrollAccount: "BALANCE",
  },
  {
    id: 86,
    region: "NCR",
    outlet: "METRO RETAILS STORES GROUP, INC. - SHAW",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "METRO RETAILS",
    payrollAccount: "BALANCE",
  },
  {
    id: 87,
    region: "NCR",
    outlet: "PIONEER CENTRE- PIONEER PASIG",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "MAGIS PASIG",
    payrollAccount: "GENTRADE",
  },
  {
    id: 88,
    region: "NCR",
    outlet: "PUREGOLD - 88 SQUARE PARANAQUE",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 89,
    region: "NCR",
    outlet: "PUREGOLD - AGLIPAY",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 90,
    region: "NCR",
    outlet: "PUREGOLD - GEN T. DE LEON",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 91,
    region: "NCR",
    outlet: "PUREGOLD MINIMART - DONA SOLEDAD",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 92,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (EXTRA) - BROOKSIDE CAINTA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 93,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (EXTRA)- PHILAM",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 94,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (EXTRA.)- A. BONIFACIO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 95,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (EXTRA.)- AMPID",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 96,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (EXTRA.)- ANGONO BAYAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 97,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (EXTRA.)- ANGONO HIGH WAY",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 98,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (EXTRA.)- GUITNANG BAYAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 99,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (EXTRA.)- OSMENA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 100,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (EXTRA.)- PANORAMA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 101,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (EXTRA.)- PARANG",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 102,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (EXTRA.)- STA. ELENA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 103,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (EXTRA.)- TAGUIG HAGONOY",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 104,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (EXTRA.)- TANDANG SORA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 105,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- 3RD AVE",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 106,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- ANTIPOLO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 107,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- BACLARAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 108,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- BALARA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 109,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- BATASAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 110,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- BETTER LIVING",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 111,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- BF HOMES",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 112,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- BLUMENTRITT CGH",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 113,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- BOCOBO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 114,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- BUSTILLOS",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 115,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- CARRIEDO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 116,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- CONCEPCION",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 117,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- DE CASTRO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 118,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- DON ANTONIO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 119,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- DOROTEO JOSE",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 120,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- DULONG BAYAN SAN MATEO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 121,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- ESPANA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 122,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- JUAN LUNA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 123,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- KALAYAAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 124,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- KARUHATAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 125,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- LIBERTAD",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 126,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- LILAC",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 127,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- MALINAO PASIG",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 128,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- MALINTA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 129,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- MARIKINA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 130,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- MERCEDEZ",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 131,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- MOTHER IGNACIA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 132,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- NANGKA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 133,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- ORTIGAS EXT EAST SUMMIT",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 134,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- PANDACAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 135,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- PAROLA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 136,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- PUREZA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 137,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- QUIRINO HI WAY",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 138,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- ROSARIO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 139,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- TAYTAY ANNEX",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 140,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- TAYTAY PALENGKE",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 141,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- TIMOG",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 142,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- TIPAS",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 143,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- USUSAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 144,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- V. MAPA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 145,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- WEST AVE.",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 146,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- ZABARTE",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 147,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- ZAPOTE ARCADE",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 148,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- ZURBARAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 149,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - 999",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 150,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - 999 CALOOCAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 151,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - AGORA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 152,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - AGUIRRE",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 153,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - AMPID SAN MATEO (G)",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 154,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - ANGONO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 155,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - ANTIPOLO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 156,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - AYALA MALL MARIKINA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 157,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - BAESA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 158,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - BAGONG SILANG",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 159,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - BAGUMBONG",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 160,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - BALINTAWAK",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 161,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - BINANGONAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 162,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - BLUMENTRITT",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 163,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - BURGOS MONTALBAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 164,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - C. RAYMUNDO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 165,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - CALOOCAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 166,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - CAMARIN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 167,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - CASIMIRO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 168,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - CHAMPACA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 169,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - CIRCUMFERENTIAL ROAD",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 170,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - COMMONWEALTH-1",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 171,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - COMMONWEALTH-2",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 172,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - CONCEPCION",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 173,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - CROSSROAD",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 174,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - CUBAO-1",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 175,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - CUBAO-2",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 176,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - CULIAT",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 177,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - DEPARO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 178,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - DIVISORIA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 179,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - DV HERBOSA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 180,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - EASTLAND",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 181,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - EXTRA COGEO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 182,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - FTI",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 183,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - GAGALANGIN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 184,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - GULOD MALAYA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 185,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - JUNCTION",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 186,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - KALENTONG 1",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 187,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - KALENTONG 2",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 188,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - KANLAON",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 189,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - KASIGLAHAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 190,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - LANGARAY",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 191,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - LANGIT ROAD",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 192,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - LAS PINAS",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 193,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - LAS PINAS 2",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 194,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - LIBERTAD",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 195,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - LIBERTAD-2",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 196,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - LIGAYA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 197,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - MAKATI-1",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 198,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - MAKATI-2",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 199,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - MALABON",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 200,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - MALANDAY",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 201,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - MALATE",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 202,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - MARCOS ALVAREZ LAS PINAS",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 203,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - MAYPAJO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 204,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - MINDANAO AVE",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 205,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - MONUMENTO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 206,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - MOONWALK",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 207,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - NAVOTAS",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 208,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - NITANG",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 209,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - NORTH COMMONWEALTH",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 210,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - NORTH COMMONWEALTH 2",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 211,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - NOVALICHES",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 212,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - ORTIGAS AVE EXT PASIG (G)",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 213,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - PACO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 214,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - PAG ASA BINANGONAN (G)",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 215,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - PARANAQUE-1",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 216,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - PARANAQUE-2",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 217,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - PASIG",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 218,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - PASO DE BLAS- 1",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 219,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - PASO DE BLAS- 2",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 220,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - PAYATAS",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 221,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - PULANG LUPA DOS",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 222,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - PULANG LUPA UNO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 223,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - Q. AVE",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 224,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - Q. PLAZA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 225,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - Q.I -1",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 226,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - Q.I -2",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 227,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - REMANVILLE",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 228,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - SAN ANTONIO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 229,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - SAN DIONISIO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 230,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - SAN ISIDRO MONTALBAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 231,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - SAN MATEO BANABA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 232,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - SAN RAFAEL",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 233,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - SHAW-1",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 234,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - SKY REGENCY",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 235,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - SOUTHGATE",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 236,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - SOUTHPARK",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 237,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - STA.MESA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 238,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - SUCAT",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 239,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - SUMULONG",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 240,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - SUSANO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 241,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - TAGUIG",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 242,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - TANAY",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 243,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - TAYTAY",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 244,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - TAYTAY -2",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 245,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - TAYTAY FLOODWAY",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 246,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - TAYUMAN-1",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 247,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - TAYUMAN-2",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 248,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - TERESA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 249,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - TERRACES",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 250,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - TS CRUZ",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 251,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - VALENZUELA-1",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 252,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - VISAYAS",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 253,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB - ZABARTE",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 254,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB -MONTALBAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 255,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUB -SUPERPALENGKE, ANTIPOLO (G)",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 256,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUP - PUTATAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 257,
    region: "NCR",
    outlet: "PUREGOLD PRICE CLUP - SHAW (2)",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 258,
    region: "NCR",
    outlet: "PUREGOLD-BAMBOO ORGAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 259,
    region: "NCR",
    outlet: "PUREGOLD-BARRANCA MINIMART",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 260,
    region: "NCR",
    outlet: "PUREGOLD-BAYANAN EXTRA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 261,
    region: "NCR",
    outlet: "PUREGOLD-DV SAN ISIDRO TAYTAY",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 262,
    region: "NCR",
    outlet: "PUREGOLD-DV SAN MIGUEL PASIG",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 263,
    region: "NCR",
    outlet: "PUREGOLD-DV TAYTAY",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 264,
    region: "NCR",
    outlet: "PUREGOLD-GOLDEN ACRES",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 265,
    region: "NCR",
    outlet: "PUREGOLD-MONTILLANO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 266,
    region: "NCR",
    outlet: "PUREGOLD-PILAR VILLAGE",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 267,
    region: "NCR",
    outlet: "PUREGOLD-PRIMO CRUZ MINIMART",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 268,
    region: "NCR",
    outlet: "PUREGOLD-SIKAP MINIMART",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 269,
    region: "NCR",
    outlet: "ROBINSON EASYMART - NOVALICHES",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 270,
    region: "NCR",
    outlet: "ROBINSON EASYMART- MARIKINA HEIGHTS",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 271,
    region: "NCR",
    outlet: "ROBINSON PLACE - OTIS",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 272,
    region: "NCR",
    outlet: "ROBINSON SUPERMARKET - ONE AYALA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 273,
    region: "NCR",
    outlet: "ROBINSONS - 8 FORBES TOWN ROAD TAGUIG.",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 274,
    region: "NCR",
    outlet: "ROBINSONS - ACACIA ESCALADES PASIG",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 275,
    region: "NCR",
    outlet: "ROBINSONS - BANAWE",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 276,
    region: "NCR",
    outlet: "ROBINSONS - BF AGUIRRE",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 277,
    region: "NCR",
    outlet: "ROBINSONS - BIGNAY VALENZUELA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 278,
    region: "NCR",
    outlet: "ROBINSONS - BLUEWAVE MARIKINA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 279,
    region: "NCR",
    outlet: "ROBINSONS - CALIFORNIA MANDALUYONG",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 280,
    region: "NCR",
    outlet: "ROBINSONS - CLOVERLEAF MALL.",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 281,
    region: "NCR",
    outlet: "ROBINSONS - COMMONWEALTH",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 282,
    region: "NCR",
    outlet: "ROBINSONS - COMMONWEALTH(shopwise)",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 283,
    region: "NCR",
    outlet: "ROBINSONS - CONGRESSIONAL",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 284,
    region: "NCR",
    outlet: "ROBINSONS - DOÑA CARMEN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 285,
    region: "NCR",
    outlet: "ROBINSONS - EASTWOOD TECHNOPLAZA II",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 286,
    region: "NCR",
    outlet: "ROBINSONS - FEDERAL BAY GARDEN PASAY",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 287,
    region: "NCR",
    outlet: "ROBINSONS - FILINVEST BATASAN HILLS",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 288,
    region: "NCR",
    outlet: "ROBINSONS - GRACELAND PLAZA MARIKINA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 289,
    region: "NCR",
    outlet: "ROBINSONS - KARANGALAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 290,
    region: "NCR",
    outlet: "ROBINSONS - LUCKY GOLD PLAZA ORTIGAS",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 291,
    region: "NCR",
    outlet: "ROBINSONS - MADISON GALERIES MUNTINLUPA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 292,
    region: "NCR",
    outlet: "ROBINSONS - MC MALABON",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 293,
    region: "NCR",
    outlet: "ROBINSONS - MERCEDES PASIG",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 294,
    region: "NCR",
    outlet: "ROBINSONS - METRO PLAZA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 295,
    region: "NCR",
    outlet: "ROBINSONS - MONTALBAN TOWNCENTER",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 296,
    region: "NCR",
    outlet: "ROBINSONS - NOVALICHES",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 297,
    region: "NCR",
    outlet: "ROBINSONS - QUIRINO HI WAY LAGRO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 298,
    region: "NCR",
    outlet: "ROBINSONS - SOUTHPARK MALL ALABANG",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 299,
    region: "NCR",
    outlet: "ROBINSONS - SUSANO COMPLEX NOVALICHES",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 300,
    region: "NCR",
    outlet: "ROBINSONS - TANDANG SORA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 301,
    region: "NCR",
    outlet: "ROBINSONS - TIMOG",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 302,
    region: "NCR",
    outlet: "ROBINSONS - TOWNVILLE BF PARANAQUE",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 303,
    region: "NCR",
    outlet: "ROBINSONS - TOWNVILLE REGALADO FAIRVIEW",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 304,
    region: "NCR",
    outlet: "ROBINSONS - TUTUBAN CENTERMALL",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 305,
    region: "NCR",
    outlet: "ROBINSONS - VALENZUELA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 306,
    region: "NCR",
    outlet: "ROBINSONS - VENICE GRAND MCKINLEY.",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 307,
    region: "NCR",
    outlet: "ROBINSONS - VICTORY MALL",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 308,
    region: "NCR",
    outlet: "ROBINSONS - WOODSVILLE MERVILLE",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 309,
    region: "NCR",
    outlet: "ROBINSONS - ZABARTE",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 310,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - ALABANG HILLS",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 311,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - ARBORTOWNE VALENZUELA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 312,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - ARNAIZ",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 313,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - BARAS",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 314,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - BETTERLIVING",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 315,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - BONI",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 316,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - CULIAT",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 317,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - DAHLIA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 318,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - E. RODRIGUEZ SR. QC (PURITY)",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 319,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - FAIRVIEW",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 320,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - FARMERS",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 321,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - GENERAL AVENUE",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 322,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - HILL SIDE",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 323,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - HOLIDAY ISLAND B.SILANG",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 324,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - HOMES ANTIPOLO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 325,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - KAMBAL ROAD",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 326,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - KAMUNING",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 327,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - LAGRO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 328,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - LOYOLA HEIGHTS QC",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 329,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - MAGINHAWA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 330,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - MAKATI",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 331,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - MANHATTAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 332,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - MARIPOSA ARCADE KAPASIGAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 333,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - METRO PLAZA B.SILANG",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 334,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - METRO POINT TAFT",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 335,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - N' DOMINGO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 336,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - NAGA ROAD",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 337,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - OLD SAUYO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 338,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - P TUAZON",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 339,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - PATEROS",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 340,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - PEMBO MAKATI",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 341,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - PILILLA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 342,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - ROBLU CAINTA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 343,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - ROOSEVELT",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 344,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - SACRED HEART",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 345,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - SAN LORENZO",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 346,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - SAN MATEO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 347,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - SANTOLAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 348,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - STAMFORD",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 349,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - STO TOMAS PASIG",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 350,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - THE EMERALD COURT PROJECT 6",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 351,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - THE LINK",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 352,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - TOWN CENTER",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 353,
    region: "NCR",
    outlet: "ROBINSONS EASYMART - TUMANA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 354,
    region: "NCR",
    outlet: "ROBINSONS EASYMART -AMAIA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 355,
    region: "NCR",
    outlet: "ROBINSONS EASYMART -BF RESORT LP",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 356,
    region: "NCR",
    outlet: "ROBINSONS EASYMART -BINANGONAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 357,
    region: "NCR",
    outlet: "ROBINSONS EASYMART -BIRMINGHAM",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 358,
    region: "NCR",
    outlet: "ROBINSONS EASYMART -BLOCK ONE",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 359,
    region: "NCR",
    outlet: "ROBINSONS EASYMART -C.RAYMUNDO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 360,
    region: "NCR",
    outlet: "ROBINSONS EASYMART -MARCOS ALVAREZ",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 361,
    region: "NCR",
    outlet: "ROBINSONS EASYMART -ONE MERCEDES",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 362,
    region: "NCR",
    outlet: "ROBINSONS EASYMART -SANDOVAL",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 363,
    region: "NCR",
    outlet: "ROBINSONS MEYCAUAYAN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "BALANCE",
  },
  {
    id: 364,
    region: "NCR",
    outlet: "ROBINSONS PLACE - ANTIPOLO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 365,
    region: "NCR",
    outlet: "ROBINSONS PLACE - CAINTA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 366,
    region: "NCR",
    outlet: "ROBINSONS PLACE - ERMITA-1",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 367,
    region: "NCR",
    outlet: "ROBINSONS PLACE - ERMITA-2",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 368,
    region: "NCR",
    outlet: "ROBINSONS PLACE - GALLERIA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 369,
    region: "NCR",
    outlet: "ROBINSONS PLACE - LAS PINAS",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 370,
    region: "NCR",
    outlet: "ROBINSONS PLACE - MAGNOLIA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 371,
    region: "NCR",
    outlet: "ROBINSONS PLACE - MALABON",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 372,
    region: "NCR",
    outlet: "ROBINSONS PLACE - METROEAST",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 373,
    region: "NCR",
    outlet: "ROBINSONS- GATEWAY",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 374,
    region: "NCR",
    outlet: "ROBINSONS-DON ANTONIO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 375,
    region: "NCR",
    outlet: "ROBINSONS-MIRANILA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 376,
    region: "NCR",
    outlet: "SHOPWISE - ALABANG",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 377,
    region: "NCR",
    outlet: "SHOPWISE - ANTIPOLO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 378,
    region: "NCR",
    outlet: "SHOPWISE - ARANETA CUBAO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 379,
    region: "NCR",
    outlet: "SHOPWISE - CIRCUIT",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 380,
    region: "NCR",
    outlet: "SHOPWISE - MAKATI",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 381,
    region: "NCR",
    outlet: "SHOPWISE - SUCAT",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 382,
    region: "NCR",
    outlet: "SHOPWISE EXPRESS - Q. AVE",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 383,
    region: "NCR",
    outlet: "SOUTH - GROCERS BF",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "SOUTH",
    payrollAccount: "BALANCE",
  },
  {
    id: 384,
    region: "NCR",
    outlet: "SOUTH MARIKINA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "SOUTH",
    payrollAccount: "BALANCE",
  },
  {
    id: 385,
    region: "NCR",
    outlet: "SOUTH PASIG",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "SOUTH",
    payrollAccount: "BALANCE",
  },
  {
    id: 386,
    region: "NCR",
    outlet: "SOUTH SUPERMARKET - ALABANG FILINVEST",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "SOUTH",
    payrollAccount: "BALANCE",
  },
  {
    id: 387,
    region: "NCR",
    outlet: "SOUTH VALENZUELA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "SOUTH",
    payrollAccount: "BALANCE",
  },
  {
    id: 388,
    region: "NCR",
    outlet: "STA LUCIA - PHASE1",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "MAGIS PASIG",
    payrollAccount: "GENTRADE",
  },
  {
    id: 389,
    region: "NCR",
    outlet: "STA LUCIA - PHASE3",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "MAGIS PASIG",
    payrollAccount: "GENTRADE",
  },
  {
    id: 390,
    region: "NCR",
    outlet: "SUPER 8 - ALABANG",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 391,
    region: "NCR",
    outlet: "SUPER 8 - ANGONO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 392,
    region: "NCR",
    outlet: "SUPER 8 - ANTIPOLO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 393,
    region: "NCR",
    outlet: "SUPER 8 - BACLARAN",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 394,
    region: "NCR",
    outlet: "SUPER 8 - BAGONG SILANG",
    accountSupervisor: "CASERES, JAYSON",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 395,
    region: "NCR",
    outlet: "SUPER 8 - BAGUMBAYAN",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 396,
    region: "NCR",
    outlet: "SUPER 8 - BALINTAWAK",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 397,
    region: "NCR",
    outlet: "SUPER 8 - BINANGONAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 398,
    region: "NCR",
    outlet: "SUPER 8 - BLUMENTRITT",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 399,
    region: "NCR",
    outlet: "SUPER 8 - CAA LAS PINAS",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 400,
    region: "NCR",
    outlet: "SUPER 8 - CAINTA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 401,
    region: "NCR",
    outlet: "SUPER 8 - CAMARIN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 402,
    region: "NCR",
    outlet: "SUPER 8 - COGEO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 403,
    region: "NCR",
    outlet: "SUPER 8 - COMMONWEALTH",
    accountSupervisor: "CASERES, JAYSON",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 404,
    region: "NCR",
    outlet: "SUPER 8 - ERMIN GARCIA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 405,
    region: "NCR",
    outlet: "SUPER 8 - FARMERS",
    accountSupervisor: "CASERES, JAYSON",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 406,
    region: "NCR",
    outlet: "SUPER 8 - GAGALANGIN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 407,
    region: "NCR",
    outlet: "SUPER 8 - GEN. T VALENZUELA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 408,
    region: "NCR",
    outlet: "SUPER 8 - GUADALUPE",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 409,
    region: "NCR",
    outlet: "SUPER 8 - HULONG DUHAT",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 410,
    region: "NCR",
    outlet: "SUPER 8 - JACKMAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 411,
    region: "NCR",
    outlet: "SUPER 8 - KARUHATAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 412,
    region: "NCR",
    outlet: "SUPER 8 - LA HUERTA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 413,
    region: "NCR",
    outlet: "SUPER 8 - LIBERTAD",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 414,
    region: "NCR",
    outlet: "SUPER 8 - LITEX",
    accountSupervisor: "CASERES, JAYSON",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 415,
    region: "NCR",
    outlet: "SUPER 8 - MAKATI",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 416,
    region: "NCR",
    outlet: "SUPER 8 - MALIBAY",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 417,
    region: "NCR",
    outlet: "SUPER 8 - MARULAS",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 418,
    region: "NCR",
    outlet: "SUPER 8 - MASINAG",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 419,
    region: "NCR",
    outlet: "SUPER 8 - MOLAVE",
    accountSupervisor: "CASERES, JAYSON",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 420,
    region: "NCR",
    outlet: "SUPER 8 - MORONG",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 421,
    region: "NCR",
    outlet: "SUPER 8 - MUNTINLUPA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 422,
    region: "NCR",
    outlet: "SUPER 8 - NAPINDAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 423,
    region: "NCR",
    outlet: "SUPER 8 - NOVA 2",
    accountSupervisor: "CASERES, JAYSON",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 424,
    region: "NCR",
    outlet: "SUPER 8 - ORTIGAS EXT. CAINTA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 425,
    region: "NCR",
    outlet: "SUPER 8 - P. BURGOS",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 426,
    region: "NCR",
    outlet: "SUPER 8 - PACO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 427,
    region: "NCR",
    outlet: "SUPER 8 - PRITIL",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 428,
    region: "NCR",
    outlet: "SUPER 8 - RECTO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 429,
    region: "NCR",
    outlet: "SUPER 8 - ROSARIO 2",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 430,
    region: "NCR",
    outlet: "SUPER 8 - SAN JOAQUIN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 431,
    region: "NCR",
    outlet: "SUPER 8 - SAN JUAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 432,
    region: "NCR",
    outlet: "SUPER 8 - SHAW",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 433,
    region: "NCR",
    outlet: "SUPER 8 - SIGNAL (FTI)",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 434,
    region: "NCR",
    outlet: "SUPER 8 - SUCAT 2",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 435,
    region: "NCR",
    outlet: "SUPER 8 - TANAY",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 436,
    region: "NCR",
    outlet: "SUPER 8 - TANDANG SORA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 437,
    region: "NCR",
    outlet: "SUPER 8 - TATALON",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 438,
    region: "NCR",
    outlet: "SUPER 8 - TAYTAY 1",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 439,
    region: "NCR",
    outlet: "SUPER 8 - TAYTAY 2",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 440,
    region: "NCR",
    outlet: "SUPER 8 - TINAJEROS",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 441,
    region: "NCR",
    outlet: "THE MARKET PLACE - MAGALLANES",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 442,
    region: "NCR",
    outlet: "THE MARKET PLACE - MAKATI",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 443,
    region: "NCR",
    outlet: "THE MARKETPLACE - 30TH",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 444,
    region: "NCR",
    outlet: "THE MARKETPLACE - ALPHALAND",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 445,
    region: "NCR",
    outlet: "THE MARKETPLACE - AYALA ALABANG",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 446,
    region: "NCR",
    outlet: "THE MARKETPLACE - BGC",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 447,
    region: "NCR",
    outlet: "THE MARKETPLACE - CAPITOL",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 448,
    region: "NCR",
    outlet: "THE MARKETPLACE - CENTURY",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 449,
    region: "NCR",
    outlet: "THE MARKETPLACE - CORINTHIAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 450,
    region: "NCR",
    outlet: "THE MARKETPLACE - EASTBAY",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 451,
    region: "NCR",
    outlet: "THE MARKETPLACE - EASTWOOD",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 452,
    region: "NCR",
    outlet: "THE MARKETPLACE - GROOVE",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 453,
    region: "NCR",
    outlet: "THE MARKETPLACE - KATIPUNAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 454,
    region: "NCR",
    outlet: "THE MARKETPLACE - OPUS",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 455,
    region: "NCR",
    outlet: "THE MARKETPLACE - P.GUEVARRA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 456,
    region: "NCR",
    outlet: "THE MARKETPLACE - PARQAL",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 457,
    region: "NCR",
    outlet: "THE MARKETPLACE - PASEO DE ROXAS",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 458,
    region: "NCR",
    outlet: "THE MARKETPLACE - ROCKWELL",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 459,
    region: "NCR",
    outlet: "THE MARKETPLACE - SANTOLAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 460,
    region: "NCR",
    outlet: "THE MARKETPLACE - TOMAS MORATO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 461,
    region: "NCR",
    outlet: "THE MARKETPLACE - TWO CENTRAL",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 462,
    region: "NCR",
    outlet: "THE MARKETPLACE - UPTOWN",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 463,
    region: "NCR",
    outlet: "THE MARKETPLACE- MAGNOLIA",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 464,
    region: "NCR",
    outlet: "THE MARKETPLACE- SHANGRI-LA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 465,
    region: "NCR",
    outlet: "ULTRAMEGA - ARAYAT",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ULTRAMEGA",
    payrollAccount: "BALANCE",
  },
  {
    id: 466,
    region: "NCR",
    outlet: "ULTRAMEGA - ARITAO",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ULTRAMEGA",
    payrollAccount: "BALANCE",
  },
  {
    id: 467,
    region: "NCR",
    outlet: "ULTRAMEGA - BINANGONAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ULTRAMEGA",
    payrollAccount: "BALANCE",
  },
  {
    id: 468,
    region: "NCR",
    outlet: "ULTRAMEGA - CORDON",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ULTRAMEGA",
    payrollAccount: "BALANCE",
  },
  {
    id: 469,
    region: "NCR",
    outlet: "ULTRAMEGA - GUAGUA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ULTRAMEGA",
    payrollAccount: "BALANCE",
  },
  {
    id: 470,
    region: "NCR",
    outlet: "ULTRAMEGA - IFUGAO",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ULTRAMEGA",
    payrollAccount: "BALANCE",
  },
  {
    id: 471,
    region: "NCR",
    outlet: "ULTRAMEGA - MADDELA ISABELA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ULTRAMEGA",
    payrollAccount: "BALANCE",
  },
  {
    id: 472,
    region: "NCR",
    outlet: "ULTRAMEGA - SAN MATEO ISABELA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ULTRAMEGA",
    payrollAccount: "BALANCE",
  },
  {
    id: 473,
    region: "NCR",
    outlet: "ULTRAMEGA - SANGANDAAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ULTRAMEGA",
    payrollAccount: "BALANCE",
  },
  {
    id: 474,
    region: "NCR",
    outlet: "UNIMART - CAPITAL COMMON PASIG",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "NG CHAIN",
    payrollAccount: "BALANCE",
  },
  {
    id: 475,
    region: "NCR",
    outlet: "UNIMART- GREENHILLS,SANJUAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "NG CHAIN",
    payrollAccount: "BALANCE",
  },
  {
    id: 476,
    region: "NCR",
    outlet: "WALTERMART SUPERMARKET, INC. - ANTIPOLO",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 477,
    region: "NCR",
    outlet: "WALTERMART SUPERMARKET, INC. - BICUTAN",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 478,
    region: "NCR",
    outlet: "WALTERMART SUPERMARKET, INC. - CALOOCAN",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 479,
    region: "NCR",
    outlet: "WALTERMART SUPERMARKET, INC. - E.ROD",
    accountSupervisor: "CASERES, JAYSON",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 480,
    region: "NCR",
    outlet: "WALTERMART SUPERMARKET, INC. - JUNCTION",
    accountSupervisor: "CASERES, JAYSON",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 481,
    region: "NCR",
    outlet: "WALTERMART SUPERMARKET, INC. - MAKATI",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 482,
    region: "NCR",
    outlet: "WALTERMART SUPERMARKET, INC. - MUNTINLUPA WEST",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 483,
    region: "NCR",
    outlet: "WALTERMART SUPERMARKET, INC. - NORTH EDSA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 484,
    region: "NCR",
    outlet: "WALTERMART SUPERMARKET, INC. - PASAY",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 485,
    region: "NCR",
    outlet: "WALTERMART SUPERMARKET, INC. - SUCAT",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 486,
    region: "NCR",
    outlet: "WALTERMART SUPERMARKET, INC. - TAYTAY",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 487,
    region: "NCR",
    outlet: "WALTERMART SUPERMARKET, INC. - VISAYAS AVE",
    accountSupervisor: "CASERES, JAYSON",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 488,
    region: "REGION 1",
    outlet: "GEN. TRADE - ERGO SUPERMARKET",
    accountSupervisor: "CASERES, JAYSON",
    adp: "GENTRADE",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 489,
    region: "REGION 1",
    outlet: "GEN. TRADE - JTC SUPERMARKET",
    accountSupervisor: "CASERES, JAYSON",
    adp: "GENTRADE",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 490,
    region: "REGION 1",
    outlet: "GEN. TRADE - ROSE GROCERY (MY KENT)",
    accountSupervisor: "CASERES, JAYSON",
    adp: "GENTRADE",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 491,
    region: "REGION 1",
    outlet: "GEN. TRADE BAMBI SUPERMARKET",
    accountSupervisor: "CASERES, JAYSON",
    adp: "GENTRADE",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 492,
    region: "REGION 1",
    outlet: "GEN. TRADE JELRA SUPERMARKET",
    accountSupervisor: "CASERES, JAYSON",
    adp: "GENTRADE",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 493,
    region: "REGION 1",
    outlet: "PUREGOLD PRICE CLUB (JR.)- BAYAMBANG",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 494,
    region: "REGION 1",
    outlet: "PUREGOLD PRICE CLUB (JR.)- BONUAN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 495,
    region: "REGION 1",
    outlet: "PUREGOLD PRICE CLUB - BACNOTAN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 496,
    region: "REGION 1",
    outlet: "PUREGOLD PRICE CLUB - CALASIAO",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 497,
    region: "REGION 1",
    outlet: "PUREGOLD PRICE CLUB - LA UNION",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 498,
    region: "REGION 1",
    outlet: "PUREGOLD PRICE CLUB - LAOAG",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 499,
    region: "REGION 1",
    outlet: "PUREGOLD PRICE CLUB - MANAOAG",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 500,
    region: "REGION 1",
    outlet: "PUREGOLD PRICE CLUB - MAYOMBO",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 501,
    region: "REGION 1",
    outlet: "PUREGOLD PRICE CLUB - SAN FABIAN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 502,
    region: "REGION 1",
    outlet: "PUREGOLD PRICE CLUB - VIGAN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 503,
    region: "REGION 1",
    outlet: "PUREGOLD PRICE CLUB - VILLASIS",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 504,
    region: "REGION 1",
    outlet: "PUREGOLD PRICE CLUB URDANETA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 505,
    region: "REGION 1",
    outlet: "PUREGOLD-MANGATAREM",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 506,
    region: "REGION 1",
    outlet: "ROBINSON - ILOCOS",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 507,
    region: "REGION 1",
    outlet: "ROBINSONS - NEPOMALL DAGUPAN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 508,
    region: "REGION 1",
    outlet: "ROBINSONS - SAN CARLOS TOWN CENTER PANGASINAN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 509,
    region: "REGION 1",
    outlet: "ROBINSONS - XENTRO MALL VIGAN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 510,
    region: "REGION 1",
    outlet: "ROBINSONS -LA UNION",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 511,
    region: "REGION 1",
    outlet: "ROBINSONS PLACE - PANGASINAN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 512,
    region: "REGION 1",
    outlet: "SUPER 8 - MANAOAG",
    accountSupervisor: "CASERES, JAYSON",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 513,
    region: "REGION 1",
    outlet: "SUPER 8 - URDANETA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 514,
    region: "REGION 1",
    outlet: "ROBINSONS - URDANETA PANGASINAN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 515,
    region: "REGION 2",
    outlet: "GEN. TRADE - LAIDAS CEDRON GROCERY",
    accountSupervisor: "CASERES, JAYSON",
    adp: "GENTRADE",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 516,
    region: "REGION 2",
    outlet: "GEN. TRADE MELBA GROCERY",
    accountSupervisor: "CASERES, JAYSON",
    adp: "GENTRADE",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 517,
    region: "REGION 2",
    outlet: "GEN. TRADE UP TO DATE GROCERY",
    accountSupervisor: "CASERES, JAYSON",
    adp: "GENTRADE",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 518,
    region: "REGION 2",
    outlet: "PUREGOLD PRICE CLUB (EXTRA.)- TUGUEGARAO",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 519,
    region: "REGION 2",
    outlet: "PUREGOLD PRICE CLUB (JR.)- OLD CENTRO",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 520,
    region: "REGION 2",
    outlet: "PUREGOLD PRICE CLUB - ALIBAGU",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 521,
    region: "REGION 2",
    outlet: "PUREGOLD PRICE CLUB - APPARI",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 522,
    region: "REGION 2",
    outlet: "PUREGOLD PRICE CLUB - BUNTUN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 523,
    region: "REGION 2",
    outlet: "PUREGOLD PRICE CLUB - CABATUAN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 524,
    region: "REGION 2",
    outlet: "PUREGOLD PRICE CLUB - ILAGAN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 525,
    region: "REGION 2",
    outlet: "PUREGOLD PRICE CLUB - LAL-LO",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 526,
    region: "REGION 2",
    outlet: "PUREGOLD PRICE CLUB - ROXAS ISABELA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 527,
    region: "REGION 2",
    outlet: "PUREGOLD PRICE CLUB - SANTIAGO HIGHWAY",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 528,
    region: "REGION 2",
    outlet: "PUREGOLD PRICE CLUB - SOLANA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 529,
    region: "REGION 2",
    outlet: "PUREGOLD PRICE CLUB - TABUK",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 530,
    region: "REGION 2",
    outlet: "PUREGOLD PRICE CLUB - TUAO",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 531,
    region: "REGION 2",
    outlet: "PUREGOLD PRICE CLUB - TUMAUINI",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 532,
    region: "REGION 2",
    outlet: "PUREGOLD PRICE CLUB - VICTORY NORTE SANTIAGO (N.E)",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 533,
    region: "REGION 2",
    outlet: "PUREGOLD-ALLACAPAN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 534,
    region: "REGION 2",
    outlet: "ROBINSON BAYOMBONG",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 535,
    region: "REGION 2",
    outlet: "ROBINSONS - ALICIA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 536,
    region: "REGION 2",
    outlet: "ROBINSONS - TALAVERA SQUARE ILAGAN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 537,
    region: "REGION 2",
    outlet: "ROBINSONS PLACE - SANTIAGO",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 538,
    region: "REGION 2",
    outlet: "ROBINSONS TUGUEGARAO",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 539,
    region: "REGION 3",
    outlet: "EVERPLUS SUPERSTORE INC. - MUZON",
    accountSupervisor: "CASERES, JAYSON",
    adp: "EVERPLUS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 540,
    region: "REGION 3",
    outlet: "EVERPLUS SUPERSTORE INC. - SAPANG PALAY",
    accountSupervisor: "CASERES, JAYSON",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 541,
    region: "REGION 3",
    outlet: "GEN. TRADE - BAYAMBANG GROCERY",
    accountSupervisor: "CASERES, JAYSON",
    adp: "GENTRADE",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 542,
    region: "REGION 3",
    outlet: "PUREGOLD - SAN LEONARDO",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 543,
    region: "REGION 3",
    outlet: "PUREGOLD DV - BUNSURAN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 544,
    region: "REGION 3",
    outlet: "PUREGOLD DV - ORANI",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 545,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB (EXTRA.)- APALIT",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 546,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB (EXTRA.)- MACABEBE",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 547,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB (JR.)- ABUCAY",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 548,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB (JR.)- CALVARIO",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 549,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB (JR.)- CAMALIG",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 550,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB (JR.)- DON JUICO",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 551,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB (JR.)- GUAGUA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 552,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB (JR.)- HERMOSA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 553,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB (JR.)- LOMA DE GATO",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 554,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB (JR.)- LUBAO",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 555,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB (JR.)- ORANI",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 556,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB (JR.)- PALM PLAZA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 557,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB (JR.)- PANDI",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 558,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB (JR.)- PORAC",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 559,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB (JR.)- SAPANG PALAY , SAMPOL",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 560,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB (JR.)- SASMUAN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 561,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB (JR.)- SF 1 DOLORES",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 562,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB (JR.)- SF 2 CAFÉ FERNANDINO",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 563,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB (JR.)- STO.TOMAS",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 564,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB (JR.)-BALIBAGO",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 565,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - ALIW",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 566,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - ANGELES",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 567,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - ANGELES - MAGALANG ROAD EPZA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 568,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - ARAYAT PAMPANGA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 569,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - BALANGA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 570,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - BALER (N.E)",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 571,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - BALIWAG",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 572,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - BOCAUE",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 573,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - BULAKAN,BULAKAN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 574,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - BULAON",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 575,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - BUSTOS",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 576,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - CABANATUAN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 577,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - CABANATUAN PALENGKE (N.E)",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 578,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - CASA CECILIA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 579,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - CASTILLEJOS",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 580,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - CENTRAL TOWN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 581,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - CIRCUMFERENCIAL (N.E)",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 582,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - CONCEPCION TARLAC",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 583,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - CROSSING (N.E)",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 584,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - DAU",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 585,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - DAU 2",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 586,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - DAU ACCESS ROAD",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 587,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - DINALUPIHAN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 588,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - DRT HI-WAY (N.E)",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 589,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - FERTUNA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 590,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - GUIMBA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 591,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - GUINGUINTO BAYAN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 592,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - HAGONOY BULACAN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 593,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - LIAS MARILAO",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 594,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - LIMAY",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 595,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - MABALACAT",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 596,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - MAGALANG PAMPANGA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 597,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - MALOLOS",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 598,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - MALOLOS JUNCTION",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 599,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - MARIA AURORA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 600,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - MARILAO PLAZA CECILIA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 601,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - MARIVELES",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 602,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - MASANTOL",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 603,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - MAUNLAD",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 604,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - MAWAQUE",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 605,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - MEXICO",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 606,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - MEYCAUAYAN BANGA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 607,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - MUZON",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 608,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - OBANDO",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 609,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - OLONGAPO",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 610,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - PACIFIC MALL (N.E)",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 611,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - PANDAN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 612,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - PANIQUI",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 613,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - PAOMBONG",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 614,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - PLARIDEL",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 615,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - PUBLIC MARKET",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 616,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - SAN ILDEFONSO",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 617,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - SAN JOSE DEL MONTE PALMERA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 618,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - SAN JOSE NUEVA ECIJA (N.E)",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 619,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - SAN MIGUEL BULACAN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 620,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - SAN SIMON",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 621,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - SINDALAN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 622,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - STA.MARIA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 623,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - STA.MARIA BAYAN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 624,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - SUBIC",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 625,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - TABANG GUIGUINTO",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 626,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - TALAVERA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 627,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - TANGOS BALIWAG",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 628,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - TUNGKONG MANGGA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 629,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - ZARAGOZA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 630,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB - ZULUETA (N.E)",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 631,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB -CANDABA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 632,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB -DUTY FREE",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 633,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB-CABIAO",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 634,
    region: "REGION 3",
    outlet: "PUREGOLD PRICE CLUB-DV ALIAGA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 635,
    region: "REGION 3",
    outlet: "PUREGOLD-BACOLOR",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 636,
    region: "REGION 3",
    outlet: "PUREGOLD-CALUMPIT",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 637,
    region: "REGION 3",
    outlet: "PUREGOLD-DV ANGAT",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 638,
    region: "REGION 3",
    outlet: "PUREGOLD-DV CABANATUAN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 639,
    region: "REGION 3",
    outlet: "PUREGOLD-DV MORONG",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 640,
    region: "REGION 3",
    outlet: "PUREGOLD-DV PANDI",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 641,
    region: "REGION 3",
    outlet: "PUREGOLD-DV PULILAN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 642,
    region: "REGION 3",
    outlet: "PUREGOLD-NORZAGARAY",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 643,
    region: "REGION 3",
    outlet: "PUREGOLD-SAN AGUSTIN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 644,
    region: "REGION 3",
    outlet: "PUREGOLD-TUGATOG",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 645,
    region: "REGION 3",
    outlet: "ROBINSONS - BALAGTAS",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 646,
    region: "REGION 3",
    outlet: "ROBINSONS - DOLORES SAN FERNANDO",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 647,
    region: "REGION 3",
    outlet: "ROBINSONS - GAPAN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 648,
    region: "REGION 3",
    outlet: "ROBINSONS - GCC MEXICO",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 649,
    region: "REGION 3",
    outlet: "ROBINSONS - GUAGUA TOWNCENTER",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 650,
    region: "REGION 3",
    outlet: "ROBINSONS - METROTOWN TARLAC",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 651,
    region: "REGION 3",
    outlet: "ROBINSONS - PULILAN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 652,
    region: "REGION 3",
    outlet: "ROBINSONS - TAÑEDO TARLAC",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 653,
    region: "REGION 3",
    outlet: "ROBINSONS - TOWNVILLE CABANATUAN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 654,
    region: "REGION 3",
    outlet: "ROBINSONS - XEVERA MABALACAT",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 655,
    region: "REGION 3",
    outlet: "ROBINSONS -NEPOMALL ANGELES",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 656,
    region: "REGION 3",
    outlet: "ROBINSONS EASYMART - BALER",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 657,
    region: "REGION 3",
    outlet: "ROBINSONS EASYMART - BAMBAN TARLAC",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 658,
    region: "REGION 3",
    outlet: "ROBINSONS EASYMART - CALUMPIT",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 659,
    region: "REGION 3",
    outlet: "ROBINSONS EASYMART - CASA ALSELMO MALOLOS",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 660,
    region: "REGION 3",
    outlet: "ROBINSONS EASYMART - CONCEPCION TARLAC",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 661,
    region: "REGION 3",
    outlet: "ROBINSONS EASYMART - CROWN BLDG. STO. TOMAS",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 662,
    region: "REGION 3",
    outlet: "ROBINSONS EASYMART - CUTCUT",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 663,
    region: "REGION 3",
    outlet: "ROBINSONS EASYMART - EPL",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 664,
    region: "REGION 3",
    outlet: "ROBINSONS EASYMART - FIL AM",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 665,
    region: "REGION 3",
    outlet: "ROBINSONS EASYMART - GUIMBA NUEVA ECIJA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 666,
    region: "REGION 3",
    outlet: "ROBINSONS EASYMART - HAGONOY",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 667,
    region: "REGION 3",
    outlet: "ROBINSONS EASYMART - HERMOSA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 668,
    region: "REGION 3",
    outlet: "ROBINSONS EASYMART - MAGALANG",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 669,
    region: "REGION 3",
    outlet: "ROBINSONS EASYMART - MARKET CITY",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 670,
    region: "REGION 3",
    outlet: "ROBINSONS EASYMART - MATATALAIB",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 671,
    region: "REGION 3",
    outlet: "ROBINSONS EASYMART - MUNOZ",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 672,
    region: "REGION 3",
    outlet: "ROBINSONS EASYMART - ORANI BATAAN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 673,
    region: "REGION 3",
    outlet: "ROBINSONS EASYMART - PANDAN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 674,
    region: "REGION 3",
    outlet: "ROBINSONS EASYMART - PIO",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 675,
    region: "REGION 3",
    outlet: "ROBINSONS EASYMART - PULUNG CACUTUD",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 676,
    region: "REGION 3",
    outlet: "ROBINSONS EASYMART - RIZAL NUEVA ECIJA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 677,
    region: "REGION 3",
    outlet: "ROBINSONS EASYMART - SAN MIGUEL",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 678,
    region: "REGION 3",
    outlet: "ROBINSONS EASYMART - SAN SEBASTIAN TARLAC",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 679,
    region: "REGION 3",
    outlet: "ROBINSONS EASYMART - SAN SIMON",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 680,
    region: "REGION 3",
    outlet: "ROBINSONS EASYMART - SAN VICENTE TARLAC",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 681,
    region: "REGION 3",
    outlet: "ROBINSONS EASYMART - SOLANA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 682,
    region: "REGION 3",
    outlet: "ROBINSONS EASYMART - STARHOMES",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 683,
    region: "REGION 3",
    outlet: "ROBINSONS EASYMART LIGTASAN TARLAC",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 684,
    region: "REGION 3",
    outlet: "ROBINSONS EASYMART-POBLACION",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 685,
    region: "REGION 3",
    outlet: "ROBINSONS EASYMRT - FRIENDSHIP ANGELES",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 686,
    region: "REGION 3",
    outlet: "ROBINSONS IBA, ZAMBALES (.50)",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 687,
    region: "REGION 3",
    outlet: "ROBINSONS PLACE - ANGELES",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 688,
    region: "REGION 3",
    outlet: "ROBINSONS PLACE - MALOLOS",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 689,
    region: "REGION 3",
    outlet: "ROBINSONS PLACE - PAMPANGA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 690,
    region: "REGION 3",
    outlet: "ROBINSONS PLACE - TARLAC",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 691,
    region: "REGION 3",
    outlet: "ROBINSONS SUPERMARKET - SAN MIGUEL",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 692,
    region: "REGION 3",
    outlet: "ROBINSONS-EASYMART SKYLINE",
    accountSupervisor: "VIGIL, BERNIE",
    adp: "ROBINSONS",
    payrollAccount: "BALANCE",
  },
  {
    id: 693,
    region: "REGION 3",
    outlet: "ROYAL DUTY FREE 1",
    accountSupervisor: "CASERES, JAYSON",
    adp: "RDF",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 694,
    region: "REGION 3",
    outlet: "ROYAL DUTY FREE 2",
    accountSupervisor: "CASERES, JAYSON",
    adp: "RDF",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 695,
    region: "REGION 3",
    outlet: "SOUTH MALOLOS",
    accountSupervisor: "CASERES, JAYSON",
    adp: "SOUTH",
    payrollAccount: "BALANCE",
  },
  {
    id: 696,
    region: "REGION 3",
    outlet: "SOUTH SUPERMARKET - PAMPANGA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "SOUTH",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 697,
    region: "REGION 3",
    outlet: "SUPER 8 - ANGELES",
    accountSupervisor: "CASERES, JAYSON",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 698,
    region: "REGION 3",
    outlet: "SUPER 8 - BALANGA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 699,
    region: "REGION 3",
    outlet: "SUPER 8 - GUAGUA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 700,
    region: "REGION 3",
    outlet: "SUPER 8 - HAGONOY",
    accountSupervisor: "CASERES, JAYSON",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 701,
    region: "REGION 3",
    outlet: "SUPER 8 - MALOLOS",
    accountSupervisor: "CASERES, JAYSON",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 702,
    region: "REGION 3",
    outlet: "SUPER 8 - PULILAN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 703,
    region: "REGION 3",
    outlet: "SUPER 8 - SAPANG PALAY",
    accountSupervisor: "CASERES, JAYSON",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 704,
    region: "REGION 3",
    outlet: "SUPER 8 - STA MARIA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 705,
    region: "REGION 3",
    outlet: "SUPER 8 - TARLAC 2",
    accountSupervisor: "CASERES, JAYSON",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 706,
    region: "REGION 3",
    outlet: "WALTERMART SAN RAFAEL",
    accountSupervisor: "CASERES, JAYSON",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 707,
    region: "REGION 3",
    outlet: "WALTERMART SUPERMARKET, INC. - ALTARAZA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 708,
    region: "REGION 3",
    outlet: "WALTERMART SUPERMARKET, INC. - ARAYAT",
    accountSupervisor: "CASERES, JAYSON",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 709,
    region: "REGION 3",
    outlet: "WALTERMART SUPERMARKET, INC. - BALANGA BATAAN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 710,
    region: "REGION 3",
    outlet: "WALTERMART SUPERMARKET, INC. - BALIUAG",
    accountSupervisor: "CASERES, JAYSON",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 711,
    region: "REGION 3",
    outlet: "WALTERMART SUPERMARKET, INC. - CABANATUAN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 712,
    region: "REGION 3",
    outlet: "WALTERMART SUPERMARKET, INC. - CAPAS",
    accountSupervisor: "CASERES, JAYSON",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 713,
    region: "REGION 3",
    outlet: "WALTERMART SUPERMARKET, INC. - CONCEPCION",
    accountSupervisor: "CASERES, JAYSON",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 714,
    region: "REGION 3",
    outlet: "WALTERMART SUPERMARKET, INC. - GAPAN",
    accountSupervisor: "CASERES, JAYSON",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 715,
    region: "REGION 3",
    outlet: "WALTERMART SUPERMARKET, INC. - GUIGUINTO",
    accountSupervisor: "CASERES, JAYSON",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 716,
    region: "REGION 3",
    outlet: "WALTERMART SUPERMARKET, INC. - MABALACAT",
    accountSupervisor: "CASERES, JAYSON",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 717,
    region: "REGION 3",
    outlet: "WALTERMART SUPERMARKET, INC. - MALOLOS",
    accountSupervisor: "CASERES, JAYSON",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 718,
    region: "REGION 3",
    outlet: "WALTERMART SUPERMARKET, INC. - PAMPANGA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "WALTERMART",
    payrollAccount: "",
  },
  {
    id: 719,
    region: "REGION 3",
    outlet: "WALTERMART SUPERMARKET, INC. - PANIQUI",
    accountSupervisor: "CASERES, JAYSON",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 720,
    region: "REGION 3",
    outlet: "WALTERMART SUPERMARKET, INC. - PLARIDEL",
    accountSupervisor: "CASERES, JAYSON",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 721,
    region: "REGION 3",
    outlet: "WALTERMART SUPERMARKET, INC. - SAN JOSE",
    accountSupervisor: "CASERES, JAYSON",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 722,
    region: "REGION 3",
    outlet: "WALTERMART SUPERMARKET, INC. - STA MARIA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 723,
    region: "REGION 3",
    outlet: "WALTERMART SUPERMARKET, INC. - SUBIC ZAMBALES",
    accountSupervisor: "CASERES, JAYSON",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 724,
    region: "REGION 3",
    outlet: "WALTERMART SUPERMARKET, INC. - TALAVERA",
    accountSupervisor: "CASERES, JAYSON",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 725,
    region: "REGION 3",
    outlet: "WALTERMART SUPERMARKET, INC- PORAC",
    accountSupervisor: "CASERES, JAYSON",
    adp: "WALTERMART",
    payrollAccount: "",
  },
  {
    id: 726,
    region: "REGION 4A",
    outlet: "AMY ABAD",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "GENTRADE",
    payrollAccount: "BALANCE",
  },
  {
    id: 727,
    region: "REGION 4A",
    outlet: "EDRA 1 (.25)",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "GENTRADE",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 728,
    region: "REGION 4A",
    outlet: "EDRA 3 (.25)",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "GENTRADE",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 729,
    region: "REGION 4A",
    outlet: "EVERPLUS SUPERSTORE INC. - CAVITE",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 730,
    region: "REGION 4A",
    outlet: "EVERPLUS SUPERSTORE INC. - PALIPARAN",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 731,
    region: "REGION 4A",
    outlet: "EVERPLUS SUPERSTORE INC. - TRECE",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 732,
    region: "REGION 4A",
    outlet: "EVERPLUS SUPERSTORE INC. - ZAPOTE",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "EVERPLUS",
    payrollAccount: "BALANCE",
  },
  {
    id: 733,
    region: "REGION 4A",
    outlet: "GOLDEN M (.25)",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "GENTRADE",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 734,
    region: "REGION 4A",
    outlet: "JEREMYS - LEMERY",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "GENTRADE",
    payrollAccount: "BALANCE",
  },
  {
    id: 735,
    region: "REGION 4A",
    outlet: "KB ABAD",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "GENTRADE",
    payrollAccount: "BALANCE",
  },
  {
    id: 736,
    region: "REGION 4A",
    outlet: "LANDMARK - NUVALI",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "LANDMARK",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 737,
    region: "REGION 4A",
    outlet: "LIANA'S SUPERMARKET - CALAMBA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "LIANAS",
    payrollAccount: "BALANCE",
  },
  {
    id: 738,
    region: "REGION 4A",
    outlet: "LIANA'S SUPERMARKET - SAN PABLO",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "LIANAS",
    payrollAccount: "BALANCE",
  },
  {
    id: 739,
    region: "REGION 4A",
    outlet: "LIANA'S SUPERMARKET - STO TOMAS",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "LIANAS",
    payrollAccount: "BALANCE",
  },
  {
    id: 740,
    region: "REGION 4A",
    outlet: "MB MANALO (.25)",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "GENTRADE",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 741,
    region: "REGION 4A",
    outlet: "METRO RETAILS STORES GROUP, INC. - IMUS",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "METRO RETAILS",
    payrollAccount: "BALANCE",
  },
  {
    id: 742,
    region: "REGION 4A",
    outlet: "METRO RETAILS STORES GROUP, INC. - LUCENA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "METRO RETAILS",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 743,
    region: "REGION 4A",
    outlet: "METRO RETAILS STORES GROUP, INC. - TAGAYTAY",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "METRO RETAILS",
    payrollAccount: "BALANCE",
  },
  {
    id: 744,
    region: "REGION 4A",
    outlet: "PUREGOLD CROSSING EAST",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 745,
    region: "REGION 4A",
    outlet: "PUREGOLD DIVIMART - INOCENCIO",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 746,
    region: "REGION 4A",
    outlet: "PUREGOLD DIVIMART - MAMBOG",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 747,
    region: "REGION 4A",
    outlet: "PUREGOLD DIVIMART - MANGGAHAN",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 748,
    region: "REGION 4A",
    outlet: "PUREGOLD JR. ELVINDA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 749,
    region: "REGION 4A",
    outlet: "PUREGOLD JUNIOR - CABUYAO BAYAN",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 750,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB (EXTRA.)- CABUYAO BANLIC",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 751,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB (EXTRA.)- CANLUBANG",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 752,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB (EXTRA.)- GOLDEN CITY",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 753,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB (EXTRA.)- HALANG",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 754,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB (EXTRA.)- LOS BANOS",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 755,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB (EXTRA.)- MAGDIWANG",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 756,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB (EXTRA.)- MAMATID",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 757,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB (EXTRA.)- PRINZA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 758,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB (EXTRA.)- SAN PABLO",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 759,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB (EXTRA.)- TAGAYTAY",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 760,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB (EXTRA.)- TIAONG",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 761,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB (JR.)- BINAN",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 762,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB (JR.)- CANLUBANG",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 763,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB (JR.)- CROSSTOWN",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 764,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB (JR.)- DASMA BAYAN",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 765,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB (JR.)- GEN TRIAS",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 766,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB (JR.)- GOLDEN CITY",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 767,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB (JR.)- HABAY",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 768,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB (JR.)- HUGO PEREZ",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 769,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB (JR.)- LOS BANOS",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 770,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB (JR.)- MARCOS ALVAREZ",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 771,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB (JR.)- NAIC",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 772,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB (JR.)- PALIPARAN",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 773,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB (JR.)- PARIAN",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 774,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB (JR.)- SAN JUAN BATANGAS",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 775,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB (JR.)- TAGAYTAY-A",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 776,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB (MINIMART.)- MAGSAYSAY",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 777,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB (MINIMART.)- PILA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 778,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB (MINIMART.)- VILLA OLYMPIA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 779,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - ALAMINOS",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 780,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - ANABU",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 781,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - ANIBAN",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 782,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - BACOOR",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 783,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - BINAN",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 784,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - BINAN BAYAN",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 785,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - BROOKSIDE LANE",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 786,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - BUCANDALA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 787,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - BUHAY NA TUBIG",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 788,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - CALAMBA BAYAN",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 789,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - CALAUAN",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 790,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - CALICANTO",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 791,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - CALIHAN HIGHWAY",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 792,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - CANDELARIA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 793,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - CARMONA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 794,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - CROSSING CALAMBA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 795,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - DASMARINAS HIGH WAY",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 796,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - FAMY",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 797,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - GMA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 798,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - HALANG",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 799,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - KAWIT",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 800,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - LANGGAM",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 801,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - LIPA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 802,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - LUCENA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 803,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - MOLINO BLVD.",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 804,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - MOLINO ROAD",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 805,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - MOLINO TOWN CENTER",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 806,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - NEW MARKET BATANGAS (G)",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 807,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - NIA ROAD",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 808,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - NOVELETA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 809,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - NOVELETA OASIS",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 810,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - PACITA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 811,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - PAGSANJAN",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 812,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - ROSARIO",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 813,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - ROSARIO BATANGAS",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 814,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - SAN ISIDRO CABUYAO",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 815,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - SAN PABLO",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 816,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - SAN PEDRO",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 817,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - SILANG",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 818,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - STA. CRUZ (G)",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 819,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - STA.ROSA BALIBAGO",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 820,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - STA.ROSA BAYAN (G)",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 821,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - STO.TOMAS BATANGAS",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 822,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - TAGAPO",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 823,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - TANAUAN 1",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 824,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - TANZA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 825,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - TANZANG LUMA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 826,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - TERMINAL MALL",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 827,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - TIAONG HIGWAY",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 828,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - VICTORIA LAGUNA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 829,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - VICTORY MALL",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 830,
    region: "REGION 4A",
    outlet: "PUREGOLD-CATANAUAN",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 831,
    region: "REGION 4A",
    outlet: "PUREGOLD-DV BANLIC",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 832,
    region: "REGION 4A",
    outlet: "PUREGOLD-DV PULO",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 833,
    region: "REGION 4A",
    outlet: "PUREGOLD-DV TALISAY",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 834,
    region: "REGION 4A",
    outlet: "PUREGOLD-GUMACA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 835,
    region: "REGION 4A",
    outlet: "PUREGOLD-PARADAHAN",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 836,
    region: "REGION 4A",
    outlet: "PUREGOLD-SARIAYA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 837,
    region: "REGION 4A",
    outlet: "PUREGOLD-TALISAY BATANGAS-A",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 838,
    region: "REGION 4A",
    outlet: "RC ALVAREZ - LEMERY",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "GENTRADE",
    payrollAccount: "BALANCE",
  },
  {
    id: 839,
    region: "REGION 4A",
    outlet: "ROBINSON SUPERMARKET - LOS BANOS",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "BALANCE",
  },
  {
    id: 840,
    region: "REGION 4A",
    outlet: "ROBINSONS - BUCANDALA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 841,
    region: "REGION 4A",
    outlet: "ROBINSONS - CENTRO MALL CABUYAO",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 842,
    region: "REGION 4A",
    outlet: "ROBINSONS - EASYMART CABUYAO",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 843,
    region: "REGION 4A",
    outlet: "ROBINSONS - GALLERIA SOUTH-A",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 844,
    region: "REGION 4A",
    outlet: "ROBINSONS - GREEN GATE MALAGASANG IMUS",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 845,
    region: "REGION 4A",
    outlet: "ROBINSONS - IMALL CANLUBANG",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 846,
    region: "REGION 4A",
    outlet: "ROBINSONS - MAIN SQUARE MOLINO",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 847,
    region: "REGION 4A",
    outlet: "ROBINSONS - NUCITI CENTRAL BATANGAS",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 848,
    region: "REGION 4A",
    outlet: "ROBINSONS - PACITA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 849,
    region: "REGION 4A",
    outlet: "ROBINSONS - SILANG",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 850,
    region: "REGION 4A",
    outlet: "ROBINSONS - SOUTHWOODS MALL LAGUNA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 851,
    region: "REGION 4A",
    outlet: "ROBINSONS - SUMMIT RIDGE TAGAYTAY",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 852,
    region: "REGION 4A",
    outlet: "ROBINSONS - TAMBO LIPA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 853,
    region: "REGION 4A",
    outlet: "ROBINSONS - TARGETMALL STA. ROSA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 854,
    region: "REGION 4A",
    outlet: "ROBINSONS - TOWNVILLE ARVO DASMARINAS",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 855,
    region: "REGION 4A",
    outlet: "ROBINSONS - TOWNVILLE BUHAY NA TUBIG",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 856,
    region: "REGION 4A",
    outlet: "ROBINSONS - TOWNVILLE NUVALI STA ROSA-1",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 857,
    region: "REGION 4A",
    outlet: "ROBINSONS - TWINLAKES VILLAGE BATANGAS",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 858,
    region: "REGION 4A",
    outlet: "ROBINSONS - XENTRO MALL LEMERY BATANGAS-A",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 859,
    region: "REGION 4A",
    outlet: "ROBINSONS - XENTRO MALL LEMERY BATANGAS-B",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 860,
    region: "REGION 4A",
    outlet: "ROBINSONS EASYMART - ALIMA BAY BACOOR",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 861,
    region: "REGION 4A",
    outlet: "ROBINSONS EASYMART - BUHAY NA TUBIG",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 862,
    region: "REGION 4A",
    outlet: "ROBINSONS EASYMART - CALACA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 863,
    region: "REGION 4A",
    outlet: "ROBINSONS EASYMART - CALAMBA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 864,
    region: "REGION 4A",
    outlet: "ROBINSONS EASYMART - HARMONY",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 865,
    region: "REGION 4A",
    outlet: "ROBINSONS EASYMART - HERMANOS SAN PABLO",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 866,
    region: "REGION 4A",
    outlet: "ROBINSONS EASYMART - HILARIO SAN PABLO",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 867,
    region: "REGION 4A",
    outlet: "ROBINSONS EASYMART - LANCASTER",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 868,
    region: "REGION 4A",
    outlet: "ROBINSONS EASYMART - NAIC CAVITE CITY",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "BALANCE",
  },
  {
    id: 869,
    region: "REGION 4A",
    outlet: "ROBINSONS EASYMART - P. BURGOS CAVITE CITY",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "BALANCE",
  },
  {
    id: 870,
    region: "REGION 4A",
    outlet: "ROBINSONS EASYMART - SAN LUCAS SAN PABLO",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 871,
    region: "REGION 4A",
    outlet: "ROBINSONS EASYMART - TANZA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 872,
    region: "REGION 4A",
    outlet: "ROBINSONS EASYMART -SILANG",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 873,
    region: "REGION 4A",
    outlet: "ROBINSONS PLACE - DASMARINAS",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 874,
    region: "REGION 4A",
    outlet: "ROBINSONS PLACE - GENERAL TRIAS",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 875,
    region: "REGION 4A",
    outlet: "ROBINSONS PLACE - IMUS",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 876,
    region: "REGION 4A",
    outlet: "ROBINSONS PLACE - LIMA EXCHANGE",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 877,
    region: "REGION 4A",
    outlet: "ROBINSONS PLACE - LIPA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 878,
    region: "REGION 4A",
    outlet: "ROBINSONS PLACE - STA ROSA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 879,
    region: "REGION 4A",
    outlet: "ROBINSONS STA. CRUZ",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 880,
    region: "REGION 4A",
    outlet: "SHOPWISE - BATANGAS",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 881,
    region: "REGION 4A",
    outlet: "SHOPWISE - IMUS",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 882,
    region: "REGION 4A",
    outlet: "SHOPWISE - LANCASTER",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 883,
    region: "REGION 4A",
    outlet: "SHOPWISE - PACITA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 884,
    region: "REGION 4A",
    outlet: "SHOPWISE - STA.ROSA(PASEO)",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 885,
    region: "REGION 4A",
    outlet: "SOUTH BRENT",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "SOUTH",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 886,
    region: "REGION 4A",
    outlet: "SOUTH LIPA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "SOUTH",
    payrollAccount: "BALANCE",
  },
  {
    id: 887,
    region: "REGION 4A",
    outlet: "SOUTH STO TOMAS",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "SOUTH",
    payrollAccount: "BALANCE",
  },
  {
    id: 888,
    region: "REGION 4A",
    outlet: "SOUTH SUPERMARKET -LOS BANOS",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "SOUTH",
    payrollAccount: "BALANCE",
  },
  {
    id: 889,
    region: "REGION 4A",
    outlet: "SOUTH SUPERMARKET -PASEO STA ROSA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "SOUTH",
    payrollAccount: "BALANCE",
  },
  {
    id: 890,
    region: "REGION 4A",
    outlet: "SUPER 8 - BINAN",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 891,
    region: "REGION 4A",
    outlet: "SUPER 8 - CABUYAO",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 892,
    region: "REGION 4A",
    outlet: "SUPER 8 - DASMARINAS",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 893,
    region: "REGION 4A",
    outlet: "SUPER 8 - GMA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 894,
    region: "REGION 4A",
    outlet: "SUPER 8 - LIPA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 895,
    region: "REGION 4A",
    outlet: "SUPER 8 - ROSARIO",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 896,
    region: "REGION 4A",
    outlet: "SUPER 8 - SAN PABLO",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 897,
    region: "REGION 4A",
    outlet: "SUPER 8 - SAN PEDRO",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 898,
    region: "REGION 4A",
    outlet: "SUPER 8 - STA ROSA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 899,
    region: "REGION 4A",
    outlet: "SUPER 8 - TRECE",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "SUPER 8",
    payrollAccount: "BALANCE",
  },
  {
    id: 900,
    region: "REGION 4A",
    outlet: "THE MARKETPLACE- WESTBORROUGH",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 901,
    region: "REGION 4A",
    outlet: "WALTERMART SUPERMARKET, INC. - BACOOR",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 902,
    region: "REGION 4A",
    outlet: "WALTERMART SUPERMARKET, INC. - BALAYAN",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 903,
    region: "REGION 4A",
    outlet: "WALTERMART SUPERMARKET, INC. - BATANGAS",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 904,
    region: "REGION 4A",
    outlet: "WALTERMART SUPERMARKET, INC. - BEL-AIR",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 905,
    region: "REGION 4A",
    outlet: "WALTERMART SUPERMARKET, INC. - CABUYAO",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 906,
    region: "REGION 4A",
    outlet: "WALTERMART SUPERMARKET, INC. - CANDELARIA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 907,
    region: "REGION 4A",
    outlet: "WALTERMART SUPERMARKET, INC. - CARMONA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 908,
    region: "REGION 4A",
    outlet: "WALTERMART SUPERMARKET, INC. - DASMA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 909,
    region: "REGION 4A",
    outlet: "WALTERMART SUPERMARKET, INC. - GEN. TRIAS",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 910,
    region: "REGION 4A",
    outlet: "WALTERMART SUPERMARKET, INC. - IMUS",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 911,
    region: "REGION 4A",
    outlet: "WALTERMART SUPERMARKET, INC. - LOS BANOS",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 912,
    region: "REGION 4A",
    outlet: "WALTERMART SUPERMARKET, INC. - MAKILING",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 913,
    region: "REGION 4A",
    outlet: "WALTERMART SUPERMARKET, INC. - NAIC",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 914,
    region: "REGION 4A",
    outlet: "WALTERMART SUPERMARKET, INC. - NASUGBU",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 915,
    region: "REGION 4A",
    outlet: "WALTERMART SUPERMARKET, INC. - PASCUAL",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 916,
    region: "REGION 4A",
    outlet: "WALTERMART SUPERMARKET, INC. - SILANG",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 917,
    region: "REGION 4A",
    outlet: "WALTERMART SUPERMARKET, INC. - STA. CRUZ",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 918,
    region: "REGION 4A",
    outlet: "WALTERMART SUPERMARKET, INC. - STA. ROSA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 919,
    region: "REGION 4A",
    outlet: "WALTERMART SUPERMARKET, INC. - TAGAYTAY",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 920,
    region: "REGION 4A",
    outlet: "WALTERMART SUPERMARKET, INC. - TANAUAN",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 921,
    region: "REGION 4A",
    outlet: "WALTERMART SUPERMARKET, INC. - TRECE MAR",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "WALTERMART",
    payrollAccount: "BALANCE",
  },
  {
    id: 922,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - STA ROSA GATEWAY",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "",
  },
  {
    id: 923,
    region: "REGION 4A",
    outlet: "PUREGOLD PRICE CLUB - DIVIMART SAN PABLO",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "",
  },
  {
    id: 924,
    region: "REGION 4A",
    outlet: "SOUTH - CALAMBA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "SOUTH",
    payrollAccount: "",
  },
  {
    id: 925,
    region: "REGION 4B",
    outlet: "PUREGOLD - BONGABONG",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 926,
    region: "REGION 4B",
    outlet: "PUREGOLD - CALAPAN",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 927,
    region: "REGION 4B",
    outlet: "PUREGOLD PRICE CLUB - BOAC MARINDUQUE",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 928,
    region: "REGION 4B",
    outlet: "PUREGOLD PRICE CLUB - ROXAS MINDORO",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 929,
    region: "REGION 4B",
    outlet: "PUREGOLD-PINAMALAYAN",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 930,
    region: "REGION 4B",
    outlet: "ROBINSONS - CALAPAN",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 931,
    region: "REGION 4B",
    outlet: "ROBINSONS PLACE - PALAWAN",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 932,
    region: "REGION 4B",
    outlet: "SOUTH EMERALD BOAC (.25)",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "GENTRADE",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 933,
    region: "REGION 4B",
    outlet: "SOUTH EMERALD GASAN (.25)",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "GENTRADE",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 934,
    region: "REGION 5",
    outlet: "METRO RETAILS STORES GROUP, INC. - LEGAZPI",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "METRO RETAILS",
    payrollAccount: "BALANCE",
  },
  {
    id: 935,
    region: "REGION 5",
    outlet: "METRO RETAILS STORES GROUP, INC. - NAGA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "METRO RETAILS",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 936,
    region: "REGION 5",
    outlet: "METRO- GUINOBATAN",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "METRO RETAILS",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 937,
    region: "REGION 5",
    outlet: "METRO- LIGAO",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "METRO RETAILS",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 938,
    region: "REGION 5",
    outlet: "PUREGOLD PRICE CLUB - CALABANGA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 939,
    region: "REGION 5",
    outlet: "PUREGOLD PRICE CLUB - CENTRO NAGA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 940,
    region: "REGION 5",
    outlet: "PUREGOLD PRICE CLUB - DAET",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 941,
    region: "REGION 5",
    outlet: "PUREGOLD PRICE CLUB - DARAGA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 942,
    region: "REGION 5",
    outlet: "PUREGOLD PRICE CLUB - IRIGA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 943,
    region: "REGION 5",
    outlet: "PUREGOLD PRICE CLUB - IROSIN SORSOGON",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 944,
    region: "REGION 5",
    outlet: "PUREGOLD PRICE CLUB - LABO",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 945,
    region: "REGION 5",
    outlet: "PUREGOLD PRICE CLUB - LEGAZPI ALBAY",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 946,
    region: "REGION 5",
    outlet: "PUREGOLD PRICE CLUB - NAGA DIVERSION",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 947,
    region: "REGION 5",
    outlet: "PUREGOLD PRICE CLUB - PILI",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 948,
    region: "REGION 5",
    outlet: "PUREGOLD PRICE CLUB - SORSOGON",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 949,
    region: "REGION 5",
    outlet: "PUREGOLD PRICE CLUB - TABACO",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 950,
    region: "REGION 5",
    outlet: "ROBINSONS - ALBAY 738 LEGAZPI",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 951,
    region: "REGION 5",
    outlet: "ROBINSONS - EMALL NAGA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 952,
    region: "REGION 5",
    outlet: "ROBINSONS PLACE - NAGA",
    accountSupervisor: "ZABALLA, FERCEY",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 953,
    region: "REGION 6",
    outlet: "PUREGOLD - BAYAWAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 954,
    region: "REGION 6",
    outlet: "PUREGOLD - CADIZ",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 955,
    region: "REGION 6",
    outlet: "PUREGOLD - CALINOG",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 956,
    region: "REGION 6",
    outlet: "PUREGOLD - CANLAON",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 957,
    region: "REGION 6",
    outlet: "PUREGOLD - JARO",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 958,
    region: "REGION 6",
    outlet: "PUREGOLD - LA CASTELLANA",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 959,
    region: "REGION 6",
    outlet: "PUREGOLD - PONTEVEDRA ROXAS",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 960,
    region: "REGION 6",
    outlet: "PUREGOLD - TANJAY",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 961,
    region: "REGION 6",
    outlet: "PUREGOLD PRICE CLUB (JR.) -CENTROPLEX",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 962,
    region: "REGION 6",
    outlet: "PUREGOLD PRICE CLUB - ANTIQUE",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 963,
    region: "REGION 6",
    outlet: "PUREGOLD PRICE CLUB - BAROTAC NUEVO",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 964,
    region: "REGION 6",
    outlet: "PUREGOLD PRICE CLUB - BAROTAC VIEJO",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 965,
    region: "REGION 6",
    outlet: "PUREGOLD PRICE CLUB - BURGOS",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 966,
    region: "REGION 6",
    outlet: "PUREGOLD PRICE CLUB - CABATUAN 2",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 967,
    region: "REGION 6",
    outlet: "PUREGOLD PRICE CLUB - ESCALANTE",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 968,
    region: "REGION 6",
    outlet: "PUREGOLD PRICE CLUB - KABANKALAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 969,
    region: "REGION 6",
    outlet: "PUREGOLD PRICE CLUB - LEGAZPI",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 970,
    region: "REGION 6",
    outlet: "PUREGOLD PRICE CLUB - LIBERTAD BACOLOD",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 971,
    region: "REGION 6",
    outlet: "PUREGOLD PRICE CLUB - MANSILINGAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 972,
    region: "REGION 6",
    outlet: "PUREGOLD PRICE CLUB - PAVIA",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 973,
    region: "REGION 6",
    outlet: "PUREGOLD PRICE CLUB - STA.BARBARA",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 974,
    region: "REGION 6",
    outlet: "PUREGOLD PRICE CLUB -888 CHINA TOWN SQUARE",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 975,
    region: "REGION 6",
    outlet: "PUREGOLD PRICE CLUB -BATA BACOLOD",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 976,
    region: "REGION 6",
    outlet: "PUREGOLD PRICE CLUB -BAYBAY GOODSHOP",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 977,
    region: "REGION 6",
    outlet: "PUREGOLD PRICE CLUB -HINIGARAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 978,
    region: "REGION 6",
    outlet: "PUREGOLD PRICE CLUB -MURCIA",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 979,
    region: "REGION 6",
    outlet: "PUREGOLD PRICE CLUB -PORT BACOLOD",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 980,
    region: "REGION 6",
    outlet: "PUREGOLD PRICE CLUB -PUEBLO DE PANAY",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 981,
    region: "REGION 6",
    outlet: "PUREGOLD PRICE CLUB -SAN CARLOS",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 982,
    region: "REGION 6",
    outlet: "PUREGOLD PRICE CLUB-OTON",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 983,
    region: "REGION 6",
    outlet: "ROBINSONS - ANTIQUE",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 984,
    region: "REGION 6",
    outlet: "ROBINSONS - BACOLOD TRIANGLE",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 985,
    region: "REGION 6",
    outlet: "ROBINSONS - CITIMALL ROXAS",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 986,
    region: "REGION 6",
    outlet: "ROBINSONS - GT KABANKALAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 987,
    region: "REGION 6",
    outlet: "ROBINSONS - GT PARK PLACE MOLO",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 988,
    region: "REGION 6",
    outlet: "ROBINSONS - OPEN MARKET MANSILINGAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 989,
    region: "REGION 6",
    outlet: "ROBINSONS - PAVIA",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 990,
    region: "REGION 6",
    outlet: "ROBINSONS - VILLAMONTE",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 991,
    region: "REGION 6",
    outlet: "ROBINSONS PLACE - ILOILO",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 992,
    region: "REGION 6",
    outlet: "ROBINSONS PLACE - MANDALAGAN BACOLOD",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 993,
    region: "REGION 6",
    outlet: "ROBINSONS PLACE - ROXAS",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 994,
    region: "REGION 6",
    outlet: "ROBINSONS PLACE -JARO ILOILO",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 995,
    region: "REGION 6",
    outlet: "THE MARKETPLACE - FESTIVE WALK",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 996,
    region: "REGION 6",
    outlet: "THE MARKETPLACE - NORTH GROOVE MOLO",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 997,
    region: "REGION 6",
    outlet: "ROBINSONS - KABANKALAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 998,
    region: "REGION 7",
    outlet: "GAISANO CAPITAL - CASUNTINGAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "",
  },
  {
    id: 999,
    region: "REGION 7",
    outlet: "GAISANO CAPITAL - DANAO",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1000,
    region: "REGION 7",
    outlet: "GAISANO CAPITAL - MACTAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1001,
    region: "REGION 7",
    outlet: "GAISANO CAPITAL - OPM",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1002,
    region: "REGION 7",
    outlet: "GAISANO CAPITAL - SAVER'SMART BASAK",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "",
  },
  {
    id: 1003,
    region: "REGION 7",
    outlet: "GAISANO CAPITAL - SOUTH",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1004,
    region: "REGION 7",
    outlet: "GAISANO CAPITAL - SRP",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1005,
    region: "REGION 7",
    outlet: "GAISANO CAPITAL - TISA",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1006,
    region: "REGION 7",
    outlet: "GAISANO GRAND - BALAMBAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1007,
    region: "REGION 7",
    outlet: "GAISANO GRAND - CARCAR",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE/BROLLEE",
  },
  {
    id: 1008,
    region: "REGION 7",
    outlet: "GAISANO GRAND - CORDOVA",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1009,
    region: "REGION 7",
    outlet: "GAISANO GRAND - DUMANJUG",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1010,
    region: "REGION 7",
    outlet: "GAISANO GRAND - FIESTA MALL",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1011,
    region: "REGION 7",
    outlet: "GAISANO GRAND - FIESTA MALL 2",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1012,
    region: "REGION 7",
    outlet: "GAISANO GRAND - LILOAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1013,
    region: "REGION 7",
    outlet: "GAISANO GRAND - MACTAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1014,
    region: "REGION 7",
    outlet: "GAISANO GRAND - MINGLANILLA",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1015,
    region: "REGION 7",
    outlet: "GAISANO GRAND - MOALBOAL",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1016,
    region: "REGION 7",
    outlet: "GAISANO GRAND - NORTH BASAK",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1017,
    region: "REGION 7",
    outlet: "GAISANO GRAND - TALAMBAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1018,
    region: "REGION 7",
    outlet: "GAISANO GRAND DUMANJUG",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "BROLLEE",
  },
  {
    id: 1019,
    region: "REGION 7",
    outlet: "GAISANO GRAND MOALBOAL",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "BROLLEE",
  },
  {
    id: 1020,
    region: "REGION 7",
    outlet: "GAISANO METRO - BANILAD",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1021,
    region: "REGION 7",
    outlet: "GAISANO METRO - COLON-1",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1022,
    region: "REGION 7",
    outlet: "GAISANO METRO - COLON-2",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "BROLLEE",
  },
  {
    id: 1023,
    region: "REGION 7",
    outlet: "GAISANO METRO - IT PARK",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1024,
    region: "REGION 7",
    outlet: "GAISANO METRO - MANDAUE",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "BROLLEE",
  },
  {
    id: 1025,
    region: "REGION 7",
    outlet: "GAISANO METRO - NAGA",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1026,
    region: "REGION 7",
    outlet: "GAISANO METRO -TANKE",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "",
  },
  {
    id: 1027,
    region: "REGION 7",
    outlet: "GAISANO METRO CANDUMAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1028,
    region: "REGION 7",
    outlet: "GAISANO METRO FRESH N EASY - SHANGRILA",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1029,
    region: "REGION 7",
    outlet: "GAISANO METRO FRESH N EASY - TABOK",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1030,
    region: "REGION 7",
    outlet: "GAISANO METRO FRESH N EASY - UMAPAD",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1031,
    region: "REGION 7",
    outlet: "GAISANO METRO TAYUD LILOAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1032,
    region: "REGION 7",
    outlet: "GAISANO SAVER'SMART - BACAYAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "",
  },
  {
    id: 1033,
    region: "REGION 7",
    outlet: "GAISANO SAVER'SMART - T.PADILLA",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "",
  },
  {
    id: 1034,
    region: "REGION 7",
    outlet: "GAISANO SAVERSMART INAYAWAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "BROLLEE",
  },
  {
    id: 1035,
    region: "REGION 7",
    outlet: "GAISANO SAVERSMART SOHO",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "BROLLEE",
  },
  {
    id: 1036,
    region: "REGION 7",
    outlet: "GAISASANO METRO POBLACION",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1037,
    region: "REGION 7",
    outlet: "METRO  VALAUE MART ELORA",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "BROLLEE",
  },
  {
    id: 1038,
    region: "REGION 7",
    outlet: "METRO DUMLOG",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1039,
    region: "REGION 7",
    outlet: "METRO GAISANO - AYALA",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1040,
    region: "REGION 7",
    outlet: "METRO LG GARDEN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1041,
    region: "REGION 7",
    outlet: "METRO VALAUE MART GUN-OB",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "BROLLEE",
  },
  {
    id: 1042,
    region: "REGION 7",
    outlet: "PUREGOLD - GUADALUPE",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1043,
    region: "REGION 7",
    outlet: "PUREGOLD -TALISAY",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1044,
    region: "REGION 7",
    outlet: "PUREGOLD PRICE CLUB -GUIHULNGAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1045,
    region: "REGION 7",
    outlet: "PUREGOLD- BOHOL",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1046,
    region: "REGION 7",
    outlet: "PUREGOLD- KASAMBAGAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1047,
    region: "REGION 7",
    outlet: "PUREGOLD- MANGO",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1048,
    region: "REGION 7",
    outlet: "ROBINSON - MANTLEWOOD",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1049,
    region: "REGION 7",
    outlet: "ROBINSON EASYMART-SPRING-WOOD",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1050,
    region: "REGION 7",
    outlet: "ROBINSON EASYMART-VIVO PLACE",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1051,
    region: "REGION 7",
    outlet: "ROBINSON SUPERMARKET-FILINVEST IT PARK CEBU",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1052,
    region: "REGION 7",
    outlet: "ROBINSONS - BANILAD CEBU",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1053,
    region: "REGION 7",
    outlet: "ROBINSONS - BASELINE",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1054,
    region: "REGION 7",
    outlet: "ROBINSONS - CASIMIRA",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1055,
    region: "REGION 7",
    outlet: "ROBINSONS - ISLAND CENTRAL MACTAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1056,
    region: "REGION 7",
    outlet: "ROBINSONS - MINGLANILLA",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1057,
    region: "REGION 7",
    outlet: "ROBINSONS - PUEBLO VERDE MACTAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1058,
    region: "REGION 7",
    outlet: "ROBINSONS - SOUTH TOWN CENTER TABUNOK",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1059,
    region: "REGION 7",
    outlet: "ROBINSONS - TALAMBAN TIME SQUARE CEBU",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1060,
    region: "REGION 7",
    outlet: "ROBINSONS - TALISAY CEBU",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1061,
    region: "REGION 7",
    outlet: "ROBINSONS - TOWNVILLE PERDICES DGT",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1062,
    region: "REGION 7",
    outlet: "ROBINSONS EASYMART - BASAK",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1063,
    region: "REGION 7",
    outlet: "ROBINSONS EASYMART - CABAHUG",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1064,
    region: "REGION 7",
    outlet: "ROBINSONS EASYMART - GUN-OB",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1065,
    region: "REGION 7",
    outlet: "ROBINSONS EASYMART - NEWTOWN MACTAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1066,
    region: "REGION 7",
    outlet: "ROBINSONS EASYMART - PAJAC",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1067,
    region: "REGION 7",
    outlet: "ROBINSONS EASYMART - PARDO",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1068,
    region: "REGION 7",
    outlet: "ROBINSONS PLACE - CEBU FUENTE",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1069,
    region: "REGION 7",
    outlet: "ROBINSONS PLACE - DUMAGUETE",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1070,
    region: "REGION 7",
    outlet: "SAVEMORE - EMALL",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1071,
    region: "REGION 7",
    outlet: "SAVEMORE - PARKMALL",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1072,
    region: "REGION 7",
    outlet: "SAVEMORE CITY MALL DANAO",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "BROLLEE",
  },
  {
    id: 1073,
    region: "REGION 7",
    outlet: "SAVEMORE CITYMALL CONSOLACION",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "BROLLEE",
  },
  {
    id: 1074,
    region: "REGION 7",
    outlet: "SET UPPER ONLY",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1075,
    region: "REGION 7",
    outlet: "SHOPWISE - MAMBALING",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1076,
    region: "REGION 7",
    outlet: "SM - CONSOLACION",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1077,
    region: "REGION 7",
    outlet: "SM - INSULAR",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1078,
    region: "REGION 7",
    outlet: "SM - JMALL",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1079,
    region: "REGION 7",
    outlet: "SM - LAPU LAPU",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1080,
    region: "REGION 7",
    outlet: "SM - MACTAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1081,
    region: "REGION 7",
    outlet: "SM - MARIBAGO",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1082,
    region: "REGION 7",
    outlet: "SM - PRIMARK",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1083,
    region: "REGION 7",
    outlet: "SM - SEA SIDE CITY",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1084,
    region: "REGION 7",
    outlet: "SUPER METRO - BOGO",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1085,
    region: "REGION 7",
    outlet: "SUPER METRO - CARCAR",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "",
  },
  {
    id: 1086,
    region: "REGION 7",
    outlet: "SUPER METRO - OPON",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1087,
    region: "REGION 7",
    outlet: "SUPER METRO - TOLEDO",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1088,
    region: "REGION 7",
    outlet: "SVI NRA CEBU",
    accountSupervisor: "DOBLE, RYAN",
    adp: "BROLLEE",
    payrollAccount: "BROLLEE",
  },
  {
    id: 1089,
    region: "REGION 7",
    outlet: "THE MARKETPLACE - AYALA",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1090,
    region: "REGION 7",
    outlet: "THE MARKETPLACE - BANAWA",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1091,
    region: "REGION 7",
    outlet: "THE MARKETPLACE - GALLERIA SELECTION CEBU",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1092,
    region: "REGION 7",
    outlet: "THE MARKETPLACE - OAKRIDGE",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1093,
    region: "REGION 7A",
    outlet: "RS BELLEMAR PANGLAO BOHOL",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "",
  },
  {
    id: 1094,
    region: "REGION 8",
    outlet: "PUREGOLD PRICE CLUB - ABUCAY",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1095,
    region: "REGION 8",
    outlet: "PUREGOLD PRICE CLUB - ABUYOG",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1096,
    region: "REGION 8",
    outlet: "PUREGOLD PRICE CLUB - ALANG-ALANG",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1097,
    region: "REGION 8",
    outlet: "PUREGOLD PRICE CLUB - BATO",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1098,
    region: "REGION 8",
    outlet: "PUREGOLD PRICE CLUB - BAYBAY LEYTE",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1099,
    region: "REGION 8",
    outlet: "PUREGOLD PRICE CLUB - BORONGAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1100,
    region: "REGION 8",
    outlet: "PUREGOLD PRICE CLUB - CALANIPAWAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1101,
    region: "REGION 8",
    outlet: "PUREGOLD PRICE CLUB - CARIGARA",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1102,
    region: "REGION 8",
    outlet: "PUREGOLD PRICE CLUB - DOLORES",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1103,
    region: "REGION 8",
    outlet: "PUREGOLD PRICE CLUB - DULAG",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1104,
    region: "REGION 8",
    outlet: "PUREGOLD PRICE CLUB - KANANGA",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1105,
    region: "REGION 8",
    outlet: "PUREGOLD PRICE CLUB - MARASBARAS",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1106,
    region: "REGION 8",
    outlet: "PUREGOLD PRICE CLUB - ORMOC",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1107,
    region: "REGION 8",
    outlet: "PUREGOLD PRICE CLUB - PALO",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1108,
    region: "REGION 8",
    outlet: "PUREGOLD PRICE CLUB - REAL TACLOBAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1109,
    region: "REGION 8",
    outlet: "PUREGOLD PRICE CLUB - SOGOD",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1110,
    region: "REGION 8",
    outlet: "PUREGOLD PRICE CLUB - TANAUAN 2",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1111,
    region: "REGION 8",
    outlet: "PUREGOLD-CALBAYOG",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1112,
    region: "REGION 8",
    outlet: "PUREGOLD-GUIUAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1113,
    region: "REGION 8",
    outlet: "PUREGOLD-HINUNANGAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1114,
    region: "REGION 8",
    outlet: "ROBINSONS - ORMOC CENTRUM",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1115,
    region: "REGION 8",
    outlet: "ROBINSONS PLACE - ABUCAY TACLOBAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1116,
    region: "REGION 8",
    outlet: "ROBINSONS PLACE - ORMOC",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1117,
    region: "REGION 8",
    outlet: "ROBINSONS PLACE - TACLOBAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1118,
    region: "REGION 9",
    outlet: "AFPCES - PAGADIAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "GENTRADE",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1119,
    region: "REGION 9",
    outlet: "GEN TRADE - CAPITOL BAZAAR",
    accountSupervisor: "DOBLE, RYAN",
    adp: "GENTRADE",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1120,
    region: "REGION 9",
    outlet: "GEN TRADE - LADYS MART",
    accountSupervisor: "DOBLE, RYAN",
    adp: "GENTRADE",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1121,
    region: "REGION 9",
    outlet: "GEN TRADE - PALANA STORE",
    accountSupervisor: "DOBLE, RYAN",
    adp: "GENTRADE",
    payrollAccount: "",
  },
  {
    id: 1122,
    region: "REGION 9",
    outlet: "GEN TRADE - UNITOP COGON",
    accountSupervisor: "DOBLE, RYAN",
    adp: "GENTRADE",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1123,
    region: "REGION 9",
    outlet: "PUREGOLD PRICE CLUB - J&F MARAGUSAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1124,
    region: "REGION 9",
    outlet: "PUREGOLD PRICE CLUB - J&F MONKAYO",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1125,
    region: "REGION 9",
    outlet: "PUREGOLD PRICE CLUB - PANTUKAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1126,
    region: "REGION 9",
    outlet: "ROBINSON EASYMART - ACCASIA",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1127,
    region: "REGION 9",
    outlet: "ROBINSONS - C3 MALL PAGADIAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1128,
    region: "REGION 9",
    outlet: "ROBINSONS - CALUMPANG",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1129,
    region: "REGION 9",
    outlet: "ROBINSONS - PAGADIAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1130,
    region: "REGION 9",
    outlet: "ROBINSONS - POLOMOLOK",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1131,
    region: "REGION 9",
    outlet: "ROBINSONS - SINDANGAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1132,
    region: "REGION 10",
    outlet: "BYANT MILLING OZAMIS CITY",
    accountSupervisor: "DOBLE, RYAN",
    adp: "GENTRADE",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1133,
    region: "REGION 10",
    outlet: "GEN TRADE - RTM SALES &GROUP INC",
    accountSupervisor: "DOBLE, RYAN",
    adp: "GENTRADE",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1134,
    region: "REGION 10",
    outlet: "NOVO OZAMIS CITY",
    accountSupervisor: "DOBLE, RYAN",
    adp: "GENTRADE",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1135,
    region: "REGION 10",
    outlet: "PUREGOLD - ILIGAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1136,
    region: "REGION 10",
    outlet: "PUREGOLD PRICE CLUB - CAGAYAN DE ORO",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1137,
    region: "REGION 10",
    outlet: "PUREGOLD PRICE CLUB - OZAMIS",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1138,
    region: "REGION 10",
    outlet: "PUREGOLD PRICE CLUB - VALENCIA",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1139,
    region: "REGION 10",
    outlet: "ROBINSON - NEW VALENCIA",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1140,
    region: "REGION 10",
    outlet: "ROBINSONS - GEEGE MALL OZAMIZ",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1141,
    region: "REGION 10",
    outlet: "ROBINSONS - IPIL",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1142,
    region: "REGION 10",
    outlet: "ROBINSONS - LAVINA PARK VALENCIA",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1143,
    region: "REGION 10",
    outlet: "ROBINSONS - LIMKETKAI MALL CDO",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1144,
    region: "REGION 10",
    outlet: "ROBINSONS GUSA- CAGAYAN DE ORO",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1145,
    region: "REGION 10",
    outlet: "ROBINSONS PLACE - CAGAYAN DE ORO",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1146,
    region: "REGION 10",
    outlet: "ROBINSONS PLACE - ILIGAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1147,
    region: "REGION 10",
    outlet: "SHOPWISE - CDOC",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1148,
    region: "REGION 10",
    outlet: "THE MARKETPLACE - CDOC",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1149,
    region: "REGION 11",
    outlet: "AFPCES - PANACAN (0.25)",
    accountSupervisor: "DOBLE, RYAN",
    adp: "AFPCES",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1150,
    region: "REGION 11",
    outlet: "GEN TRADE - NCCC CHOICE PUBLIC MARKET",
    accountSupervisor: "DOBLE, RYAN",
    adp: "GENTRADE",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1151,
    region: "REGION 11",
    outlet: "GEN TRADE - NCCC HB1 BONIFACIO",
    accountSupervisor: "DOBLE, RYAN",
    adp: "GENTRADE",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1152,
    region: "REGION 11",
    outlet: "GEN TRADE - SOUTH SEAS SUPERRAMA",
    accountSupervisor: "DOBLE, RYAN",
    adp: "GENTRADE",
    payrollAccount: "GENTRADE",
  },
  {
    id: 1153,
    region: "REGION 11",
    outlet: "GEN TRADE -NCCC NOVA TIERRA",
    accountSupervisor: "DOBLE, RYAN",
    adp: "GENTRADE",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1154,
    region: "REGION 11",
    outlet: "PUREGOLD PRICE CLUB - BANSALAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1155,
    region: "REGION 11",
    outlet: "PUREGOLD PRICE CLUB - BUTUAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1156,
    region: "REGION 11",
    outlet: "PUREGOLD PRICE CLUB - COTABATO FIESTA MALL",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1157,
    region: "REGION 11",
    outlet: "PUREGOLD PRICE CLUB - COTABATO MAIN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1158,
    region: "REGION 11",
    outlet: "PUREGOLD PRICE CLUB - DIGOS",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1159,
    region: "REGION 11",
    outlet: "PUREGOLD PRICE CLUB - LANANG",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1160,
    region: "REGION 11",
    outlet: "PUREGOLD PRICE CLUB - LANGIHAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1161,
    region: "REGION 11",
    outlet: "PUREGOLD PRICE CLUB - LUPON",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1162,
    region: "REGION 11",
    outlet: "PUREGOLD PRICE CLUB - MARAWI",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1163,
    region: "REGION 11",
    outlet: "PUREGOLD PRICE CLUB - STO.TOMAS",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1164,
    region: "REGION 11",
    outlet: "PUREGOLD PRICE CLUB SIARGAO",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1165,
    region: "REGION 11",
    outlet: "ROBINSON EASYMART - ACACIA",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1166,
    region: "REGION 11",
    outlet: "ROBINSON EASYMART - DAMOSA",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1167,
    region: "REGION 11",
    outlet: "ROBINSON EASYMART - ECOLAND",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1168,
    region: "REGION 11",
    outlet: "ROBINSON-TOWNVILLE ABREEZA DAVAO",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1169,
    region: "REGION 11",
    outlet: "ROBINSONS - AL NOR MALL COTABATO",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1170,
    region: "REGION 11",
    outlet: "ROBINSONS - CYBERGATE DAVAO",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1171,
    region: "REGION 11",
    outlet: "ROBINSONS - STA LUCIA",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1172,
    region: "REGION 11",
    outlet: "ROBINSONS PLACE - BUTUAN",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1173,
    region: "REGION 11",
    outlet: "ROBINSONS PLACE - TAGUM",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1174,
    region: "REGION 12",
    outlet: "PUREGOLD PRICE CLUB - TANDAG",
    accountSupervisor: "DOBLE, RYAN",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1175,
    region: "REGION 12",
    outlet: "ROBINSONS - TANDAG",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1176,
    region: "REGION 12",
    outlet: "ROBINSONS PLACE - GENERAL SANTOS",
    accountSupervisor: "DOBLE, RYAN",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1177,
    region: "CAR",
    outlet: "PUREGOLD PRICE CLUB (JR.)- BAKAKENG",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1178,
    region: "CAR",
    outlet: "PUREGOLD PRICE CLUB - BAGUIO",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1179,
    region: "CAR",
    outlet: "PUREGOLD PRICE CLUB - BURNHAM PARK",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1180,
    region: "CAR",
    outlet: "PUREGOLD PRICE CLUB - LA TRINIDAD BENGUET",
    accountSupervisor: "CASERES, JAYSON",
    adp: "PUREGOLD",
    payrollAccount: "PUREGOLD",
  },
  {
    id: 1181,
    region: "CAR",
    outlet: "ROBINSONS - PORTA VAGA MALL BAGUIO",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
  {
    id: 1182,
    region: "CAR",
    outlet: "THE MARKETPLACE - BAGUIO",
    accountSupervisor: "CASERES, JAYSON",
    adp: "ROBINSONS",
    payrollAccount: "ROBINSONS",
  },
];

// Base outlets stay fixed above. Slots ("- 2"/"- 3") added by Account Supervisors
// live in the DB and are merged in here at runtime so all lookups see them.
let RUNTIME_OUTLETS = [...OUTLET_DATA];
function mergeSlots(slots) {
  const extra = Array.isArray(slots) ? slots : [];
  RUNTIME_OUTLETS = [...OUTLET_DATA, ...extra];
  return RUNTIME_OUTLETS;
}

const APPLICANT_STAGES = [
  "Applicant Endorsed",
  "Intro Done",
  "Back Out",
  "For Onboarding",
];

// ═════════════════════════════════════════════════════════════════════════════
// 2. HELPER FUNCTIONS
// ═════════════════════════════════════════════════════════════════════════════

function getApplicantStatusConfig(value) {
  return (
    APPLICANT_STATUS_OPTIONS.find((o) => o.value === value) || {
      value: "",
      label: "—",
      color: "#bbb",
      bg: "#fafafa",
    }
  );
}
export const APPLICANT_STATUS_OPTIONS = [
  {
    value: "For Pooling",
    label: "For Pooling",
    color: "#78909c",
    bg: "#eceff1",
    description: "Outlet is vacant — waiting for applicant",
  },
  {
    value: "Applicant Endorsed",
    label: "Applicant Endorsed",
    color: "#1565c0",
    bg: "#e3f2fd",
    description: "Applicant endorsed for this outlet",
  },
  {
    value: "Intro Done",
    label: "Intro Done",
    color: "#6a1b9a",
    bg: "#f3e5f5",
    description: "Applicant completed the intro/interview",
  },
  {
    value: "Back Out",
    label: "Back Out",
    color: "#c62828",
    bg: "#ffebee",
    description: "Applicant backed out of the process",
  },
  {
    value: "For Onboarding",
    label: "For Onboarding",
    color: "#e65100",
    bg: "#fff3e0",
    description: "Applicant cleared — awaiting onboarding",
  },
  {
    value: "Onboarded",
    label: "Onboarded",
    color: "#2e7d32",
    bg: "#e8f5e9",
    description: "Onboarded — ready for deployment",
  },
];

function isDeployUnlocked(applicantStatus, role) {
  if (["ACCOUNT SUPERVISOR", "MIS", "OPERATION ENCODER"].includes(role))
    return true;
  if (!applicantStatus || applicantStatus === "") return true;
  return applicantStatus === "Onboarded";
}

function formatDate(dateStr) {
  if (!dateStr) return "—";
  const d = new Date(dateStr);
  if (isNaN(d)) return "—";
  return d.toLocaleDateString("en-PH", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

function calcDaysUndeployed(undeployDate, deployStatus) {
  if (deployStatus === "Deployed" || !undeployDate) return null;
  const from = new Date(undeployDate);
  if (isNaN(from)) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  from.setHours(0, 0, 0, 0);
  const diff = Math.floor((today - from) / (1000 * 60 * 60 * 24));
  return diff >= 0 ? diff : 0;
}

function getDaysBadgeColor(days) {
  if (days === null) return null;
  if (days <= 7) return { bg: "#fff9c4", color: "#f57f17", border: "#ffe082" };
  if (days <= 30) return { bg: "#ffe0b2", color: "#e65100", border: "#ffcc80" };
  return { bg: "#ffcdd2", color: "#b71c1c", border: "#ef9a9a" };
}

function todayISO() {
  return new Date().toISOString().split("T")[0];
}

// ═════════════════════════════════════════════════════════════════════════════
// 3. DATA BUILDING FUNCTIONS
// ═════════════════════════════════════════════════════════════════════════════

function buildAssignmentMaps(allData) {
  const efcAll = allData.filter(
    (e) => e.clientAssigned?.toUpperCase() === "ECOSSENTIAL FOODS CORP",
  );

  const merchandisers = efcAll.filter(
    (e) =>
      ["Merchandiser", "CVS Merchandiser", "Repacker"].includes(e.position) &&
      e.status?.toLowerCase() === "active",
  );

  const efcApplicants = efcAll.filter(
    (e) =>
      ["Merchandiser", "CVS Merchandiser", "Repacker"].includes(e.position) &&
      e.status?.toLowerCase() === "applicant",
  );

  const coordinators = efcAll.filter(
    (e) =>
      ["Tactical Coordinator", "Account Coordinator"].includes(e.position) &&
      e.status?.toLowerCase() === "active",
  );

  const assignments = {};

  // Map employed merchandisers
  merchandisers.forEach((emp) => {
    const names = new Set();
    if (emp.outletsAssigned?.length > 0)
      emp.outletsAssigned.forEach((n) => names.add(n));
    if (names.size === 0 && emp.outletAssignmentHistory?.length > 0) {
      const lat =
        emp.outletAssignmentHistory[emp.outletAssignmentHistory.length - 1];
      if (lat?.outletName) names.add(lat.outletName);
    }
    names.forEach((outletName) => {
      const m = RUNTIME_OUTLETS.find((o) => o.outlet === outletName);
      if (m) {
        assignments[m.id] = {
          employeeId: emp._id,
          employeeNo: emp.employeeNo || "",
          employeeName: `${emp.lastName} ${emp.firstName}`,
          firstName: emp.firstName || "",
          lastName: emp.lastName || "",
          suffix: emp.suffix || "",
          modeOfDisbursement: emp.modeOfDisbursement || "",
          accountNumber: emp.accountNumber || "",
          deployStatus: emp.deployStatus || "Undeployed",
          deploymentType: emp.deploymentType || "Stationary",
          employmentStatus: emp.employmentStatus || "Regular",
          rateCardId: emp.rateCardId || null,
          rateCardId: emp.rateCardId ?? "",
          deployDate: emp.deployDate || null,
          undeployDate: emp.undeployDate || null,
          applicantStatus: emp.applicantStatus || "",
          backOutReason: emp.backOutReason || "",
          targetOnboardDate: emp.targetOnboardDate || null,
          temporaryDeployEndDate: emp.temporaryDeployEndDate || null,
          isApplicant: false,
          incomingApplicantId: null,
          incomingApplicantName: null,
          incomingApplicantStatus: "",
        };
      }
    });
  });

  // Map applicants
  efcApplicants.forEach((emp) => {
    const names = new Set();
    if (emp.outletsAssigned?.length > 0)
      emp.outletsAssigned.forEach((n) => names.add(n));
    if (names.size === 0 && emp.outletAssignmentHistory?.length > 0) {
      const lat =
        emp.outletAssignmentHistory[emp.outletAssignmentHistory.length - 1];
      if (lat?.outletName) names.add(lat.outletName);
    }
    names.forEach((outletName) => {
      const m = RUNTIME_OUTLETS.find((o) => o.outlet === outletName);
      if (!m) return;
      if (assignments[m.id]) {
        assignments[m.id].incomingApplicantId = emp._id;
        assignments[m.id].incomingApplicantName =
          `${emp.lastName} ${emp.firstName}`;
        assignments[m.id].incomingApplicantStatus = emp.applicantStatus || "";
        assignments[m.id].incomingBackOutReason = emp.backOutReason || "";
        assignments[m.id].incomingTargetOnboardDate =
          emp.targetOnboardDate || null;
      } else {
        assignments[m.id] = {
          employeeId: emp._id,
          employeeName: `${emp.lastName} ${emp.firstName}`,
          firstName: emp.firstName || "",
          lastName: emp.lastName || "",
          suffix: emp.suffix || "",
          modeOfDisbursement: emp.modeOfDisbursement || "",
          accountNumber: emp.accountNumber || "",
          deployStatus: emp.deployStatus || "Undeployed",
          deploymentType: emp.deploymentType || "Stationary",
          employmentStatus: emp.employmentStatus || "Regular",
          rateCardId: emp.rateCardId || null,
          rateCardId: emp.rateCardId ?? "",
          deployDate: emp.deployDate || null,
          undeployDate: emp.undeployDate || null,
          applicantStatus: emp.applicantStatus || "",
          backOutReason: emp.backOutReason || "",
          targetOnboardDate: emp.targetOnboardDate || null,
          temporaryDeployEndDate: emp.temporaryDeployEndDate || null,
          isApplicant: true,
          incomingApplicantId: null,
          incomingApplicantName: null,
          incomingApplicantStatus: "",
        };
      }
    });
  });

  // Map coordinators
  const coordAssignments = {};
  coordinators.forEach((emp) => {
    if (emp.outletsAssigned?.length > 0) {
      emp.outletsAssigned.forEach((outletName) => {
        const m = RUNTIME_OUTLETS.find((o) => o.outlet === outletName);
        if (m) {
          const safeKey = outletName.replace(/\./g, "_");
          coordAssignments[m.id] = {
            employeeId: emp._id,
            employeeName: `${emp.firstName} ${emp.lastName}`,
            status: emp.outletStatusMap?.[safeKey] || "Active",
          };
        }
      });
    }
  });

  return {
    merchandisers,
    coordinators,
    assignments,
    coordAssignments,
    efcApplicants,
  };
}

function buildSummaryData(employees, outletAssignments, type = "MERCHANDISER") {
  const map = {};
  Object.entries(outletAssignments).forEach(([outletId, a]) => {
    const empId = a.employeeId;
    const info = RUNTIME_OUTLETS.find((o) => o.id === parseInt(outletId));
    if (!info) return;
    if (!map[empId]) {
      map[empId] = {
        employeeId: empId,
        employeeName: a.employeeName,
        outlets: [],
        status: a.deployStatus || a.status,
      };
    }
    map[empId].outlets.push({
      outletName: info.outlet,
      account: info.account,
      status: type === "MERCHANDISER" ? a.deployStatus : a.status,
    });
  });

  const assigned = Object.values(map).sort((a, b) =>
    a.employeeName.localeCompare(b.employeeName),
  );

  const assignedIds = new Set(Object.keys(map));
  const floating = employees
    .filter((e) => !assignedIds.has(e._id))
    .map((e) => ({
      employeeId: e._id,
      employeeName: `${e.firstName} ${e.lastName}`,
      outlets: [],
      position: e.position || "",
    }))
    .sort((a, b) => a.employeeName.localeCompare(b.employeeName));

  return { assigned, floating };
}

// ═════════════════════════════════════════════════════════════════════════════
// 4. REACT COMPONENTS
// ═════════════════════════════════════════════════════════════════════════════

const BackOutReasonField = React.memo(function BackOutReasonField({
  value,
  onChange,
  hasError,
}) {
  return (
    <TextField
      label="Reason for Back Out *"
      fullWidth
      multiline
      rows={2}
      defaultValue={value}
      onBlur={(e) => onChange(e.target.value)}
      placeholder="Enter reason why applicant backed out..."
      error={!value && hasError}
      helperText={
        !value
          ? "⚠ Required — enter the reason for backing out"
          : `${value.length} characters`
      }
      FormHelperTextProps={{ sx: { color: !value ? "#d32f2f" : "#888" } }}
      sx={{
        "& .MuiOutlinedInput-root": {
          backgroundColor: "#fff8f8",
          border: "1px solid #ef9a9a",
        },
      }}
    />
  );
});

const TerminateReasonField = React.memo(function TerminateReasonField({
  value,
  onChange,
  hasError,
}) {
  return (
    <TextField
      label="Reason for Termination *"
      fullWidth
      multiline
      rows={2}
      defaultValue={value}
      onBlur={(e) => onChange(e.target.value)}
      placeholder="Enter the specific reason for termination..."
      error={!value && hasError}
      helperText={
        !value
          ? "⚠ Required — provide the reason for termination"
          : `${value.length} characters`
      }
      FormHelperTextProps={{ sx: { color: !value ? "#d32f2f" : "#888" } }}
      sx={{ "& .MuiOutlinedInput-root": { backgroundColor: "#fff8f0" } }}
    />
  );
});

// ═════════════════════════════════════════════════════════════════════════════
// 5. MAIN COMPONENT - OutletListRoving
//    Roving-package manager. No HR pipeline, no merchandiser assignment, no HC.
//    Account Supervisors group several outlets into one roving "package".
//    Each package gets an auto-generated Roving ID (assigned by the backend).
// ═════════════════════════════════════════════════════════════════════════════

export default function OutletListRoving() {
  // ── State ──────────────────────────────────────────────────────────────────
  const [rovingGroups, setRovingGroups] = useState([]);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  // Filters
  const [filterRegion, setFilterRegion] = useState("ALL");
  const [filterSupervisor, setFilterSupervisor] = useState("ALL");
  const [searchText, setSearchText] = useState("");

  // Create / Edit roving-package modal
  const [openGroupModal, setOpenGroupModal] = useState(false);
  const [editingGroup, setEditingGroup] = useState(null); // null = creating
  const [groupName, setGroupName] = useState("");
  const [groupSupervisor, setGroupSupervisor] = useState("");
  const [groupOutlets, setGroupOutlets] = useState([]); // array of outlet objects
  const [saving, setSaving] = useState(false);
  const [formError, setFormError] = useState("");

  // Delete confirm
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleting, setDeleting] = useState(false);

  // Snackbar
  const [snack, setSnack] = useState({ open: false, msg: "", sev: "success" });
  const notify = (msg, sev = "success") => setSnack({ open: true, msg, sev });

  // ── Permissions ──────────────────────────────────────────────────────────
  const role = localStorage.getItem("roleAccount");
  const canEdit = ["ACCOUNT SUPERVISOR", "MIS", "OPERATION ENCODER"].includes(
    role,
  );

  const API = "https://api-map.bmphrc.com";

  // ── Sidebar sync ───────────────────────────────────────────────────────────
  useEffect(() => {
    const check = () =>
      setSidebarOpen(localStorage.getItem("sidebarOpen") === "true");
    check();
    window.addEventListener("storage", check);
    const iv = setInterval(check, 100);
    return () => {
      window.removeEventListener("storage", check);
      clearInterval(iv);
    };
  }, []);

  // ── Data loading ───────────────────────────────────────────────────────────
  // Merge any outlet slots ("- 2"/"- 3") so the outlet picker sees them too.
  const fetchSlots = async () => {
    try {
      const slotRes = await axios.get(`${API}/outlet-slots`);
      mergeSlots(slotRes.data?.data || []);
    } catch (slotErr) {
      console.error("Failed to fetch outlet slots:", slotErr);
      mergeSlots([]);
    }
  };

  const fetchGroups = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API}/roving-groups`);
      setRovingGroups(res.data?.data || []);
    } catch (e) {
      console.error("Failed to fetch roving groups:", e);
      setRovingGroups([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSlots();
    fetchGroups();
  }, []);

  // ── Option lists ─────────────────────────────────────────────────────────
  const supervisorOptions = Array.from(
    new Set(
      RUNTIME_OUTLETS.map((o) => o.accountSupervisor).filter(
        (s) => s && s.trim() !== "",
      ),
    ),
  ).sort();

  const regionOptions = Array.from(
    new Set(
      RUNTIME_OUTLETS.map((o) => o.region).filter((s) => s && s.trim() !== ""),
    ),
  ).sort();

  // ── Rows (one per roving package) ──────────────────────────────────────────
  const rows = rovingGroups
    .map((g, i) => {
      const members = (g.outlets || [])
        .map((name) => RUNTIME_OUTLETS.find((o) => o.outlet === name))
        .filter(Boolean);
      return {
        id: g._id || `tmp-${i}`,
        _raw: g,
        rovingId: g.rovingId || "—",
        packageName: g.name || "(unnamed)",
        region: g.region || members[0]?.region || "",
        accountSupervisor: g.accountSupervisor || "",
        _members: members,
        _memberNames: g.outlets || [],
      };
    })
    .filter((r) => {
      if (filterRegion !== "ALL" && r.region !== filterRegion) return false;
      if (
        filterSupervisor !== "ALL" &&
        r.accountSupervisor !== filterSupervisor
      )
        return false;
      const q = searchText.trim().toLowerCase();
      if (q) {
        const hay = [
          r.rovingId,
          r.packageName,
          r.region,
          r.accountSupervisor,
          ...r._memberNames,
        ]
          .filter(Boolean)
          .join(" ")
          .toLowerCase();
        if (!hay.includes(q)) return false;
      }
      return true;
    })
    .map((r, idx) => ({ ...r, count: idx + 1 }));

  const totalPackages = rows.length;
  const totalOutlets = rows.reduce((s, r) => s + r._memberNames.length, 0);

  // ── Modal handlers ─────────────────────────────────────────────────────────
  const openCreate = () => {
    setEditingGroup(null);
    setGroupName("");
    setGroupSupervisor("");
    setGroupOutlets([]);
    setFormError("");
    setOpenGroupModal(true);
  };

  const openEdit = (group) => {
    setEditingGroup(group);
    setGroupName(group.name || "");
    setGroupSupervisor(group.accountSupervisor || "");
    setGroupOutlets(
      (group.outlets || [])
        .map((name) => RUNTIME_OUTLETS.find((o) => o.outlet === name))
        .filter(Boolean),
    );
    setFormError("");
    setOpenGroupModal(true);
  };

  const closeGroupModal = () => {
    if (saving) return;
    setOpenGroupModal(false);
    setEditingGroup(null);
  };

  const saveGroup = async () => {
    if (!groupSupervisor) {
      setFormError("Please select an Account Supervisor.");
      return;
    }
    if (groupOutlets.length < 2) {
      setFormError("A roving package needs at least 2 outlets.");
      return;
    }

    // Roving ID is assigned automatically by the backend — not sent from here.
    const payload = {
      name: groupName.trim(),
      accountSupervisor: groupSupervisor,
      region: groupOutlets[0]?.region || "",
      outlets: groupOutlets.map((o) => o.outlet),
      updatedBy: localStorage.getItem("adminFullName") || "Unknown",
      updatedByRole: role || "",
    };

    try {
      setSaving(true);
      setFormError("");
      if (editingGroup?._id) {
        await axios.put(`${API}/roving-groups/${editingGroup._id}`, payload);
        notify("Roving package updated.");
      } else {
        const res = await axios.post(`${API}/roving-groups`, payload);
        notify(
          `Roving package created${res.data?.data?.rovingId ? ` (${res.data.data.rovingId})` : ""}.`,
        );
      }
      setOpenGroupModal(false);
      setEditingGroup(null);
      await fetchGroups();
    } catch (e) {
      console.error("Failed to save roving package:", e);
      setFormError(
        e.response?.data?.message || "Failed to save. Please try again.",
      );
    } finally {
      setSaving(false);
    }
  };

  const confirmDelete = async () => {
    if (!deleteTarget?._id) return;
    try {
      setDeleting(true);
      await axios.delete(`${API}/roving-groups/${deleteTarget._id}`);
      notify("Roving package deleted.");
      setDeleteTarget(null);
      await fetchGroups();
    } catch (e) {
      console.error("Failed to delete roving package:", e);
      notify("Failed to delete. Please try again.", "error");
    } finally {
      setDeleting(false);
    }
  };

  // ── Export ─────────────────────────────────────────────────────────────────
  const handleExport = () => {
    const XLSX = require("sheetjs-style");

    const headers = [
      "Roving ID",
      "Region",
      "Account Supervisor",
      "Roving Outlet",
    ];

    // One row PER OUTLET. Roving ID simply repeats on each row.
    const aoa = [];
    rows.forEach((pkg) => {
      const names = pkg._memberNames.length ? pkg._memberNames : [""];
      names.forEach((outletName) => {
        aoa.push([pkg.rovingId, pkg.region, pkg.accountSupervisor, outletName]);
      });
    });

    const ws = XLSX.utils.aoa_to_sheet([headers, ...aoa]);
    ws["!cols"] = [{ wch: 12 }, { wch: 10 }, { wch: 22 }, { wch: 60 }];

    // Header styling
    headers.forEach((_, col) => {
      const cell = XLSX.utils.encode_cell({ r: 0, c: col });
      if (ws[cell])
        ws[cell].s = {
          font: { bold: true, color: { rgb: "FFFFFF" } },
          fill: { fgColor: { rgb: "2E6385" } },
          alignment: { horizontal: "center", vertical: "center" },
        };
    });

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Roving Packages");
    const buffer = XLSX.write(wb, { type: "array", bookType: "xlsx" });
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `EFC_Roving-Packages_${new Date().toISOString().split("T")[0]}.xlsx`;
    link.click();

    // Log the export to Recent Activity + notifications (same route as before).
    (async () => {
      try {
        await axios.post(`${API}/log-export`, {
          exportName: "EFC Roving Packages Export",
          rowCount: rows.length,
          clientAssigned: "ECOSSENTIAL FOODS CORP",
          updatedBy: localStorage.getItem("adminFullName") || "Unknown",
          updatedByRole: role || "",
        });
      } catch (err) {
        console.error("Failed to log export activity:", err);
      }
    })();
  };

  // ── Columns (one row = one roving package) ──────────────────────────────────
  const columns = [
    {
      field: "count",
      headerName: "#",
      width: 60,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "rovingId",
      headerName: "Roving ID",
      width: 130,
      renderCell: (p) => (
        <Chip
          label={p.row.rovingId}
          size="small"
          sx={{
            fontWeight: 700,
            backgroundColor: "#e3f2fd",
            color: "#1565c0",
            fontFamily: "monospace",
          }}
        />
      ),
    },
    { field: "region", headerName: "Region", width: 100 },
    {
      field: "accountSupervisor",
      headerName: "Account Supervisor",
      width: 200,
    },
    {
      field: "outlets",
      headerName: "Roving Outlets",
      width: 520,
      sortable: false,
      renderCell: (p) => (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: 0.3,
            py: 0.5,
            height: "100%",
          }}
        >
          <Typography
            variant="caption"
            sx={{ color: "#64748b", fontWeight: 600 }}
          >
            {p.row._memberNames.length} outlets merged
          </Typography>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {p.row._memberNames.map((name) => (
              <Chip
                key={name}
                label={name}
                size="small"
                sx={{
                  height: 18,
                  fontSize: "10px",
                  maxWidth: 230,
                  backgroundColor: "#eceff1",
                  color: "#455a64",
                  fontWeight: 500,
                }}
              />
            ))}
          </Box>
        </Box>
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 120,
      sortable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (p) =>
        canEdit ? (
          <Box sx={{ display: "flex", gap: 0.5 }}>
            <Tooltip title="Edit package">
              <IconButton
                size="small"
                color="primary"
                onClick={() => openEdit(p.row._raw)}
              >
                <EditIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete package">
              <IconButton
                size="small"
                sx={{ color: "#c62828" }}
                onClick={() => setDeleteTarget(p.row._raw)}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        ) : (
          <Tooltip title="View only">
            <LockIcon sx={{ fontSize: 16, color: "#b0bec5" }} />
          </Tooltip>
        ),
    },
  ];

  // ── Render ───────────────────────────────────────────────────────────────
  return (
    <>
      <Topbar />
      <Sidebar />
      <Box
        sx={{
          marginLeft: { xs: 0, md: sidebarOpen ? "280px" : "70px" },
          transition: "margin-left 0.3s ease",
          minHeight: "100vh",
          backgroundColor: "#f5f7fa",
          paddingTop: "64px",
        }}
      >
        <Box sx={{ p: 3, maxWidth: "1800px", margin: "0 auto" }}>
          {/* Header */}
          <Paper
            elevation={0}
            sx={{
              background: "linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)",
              borderRadius: 3,
              p: 3,
              mb: 3,
              color: "white",
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Avatar
              src={EFClogo}
              variant="rounded"
              sx={{ width: 56, height: 56, bgcolor: "rgba(255,255,255,0.15)" }}
            />
            <Box sx={{ flexGrow: 1 }}>
              <Typography variant="h5" sx={{ fontWeight: 700 }}>
                EFC Roving Outlets
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                Group roving outlets into packages — each gets an auto Roving ID
              </Typography>
            </Box>
            {canEdit && (
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={openCreate}
                sx={{
                  backgroundColor: "#fff",
                  color: "#1e3a5f",
                  fontWeight: 700,
                  "&:hover": { backgroundColor: "#e2e8f0" },
                }}
              >
                Create Roving Package
              </Button>
            )}
          </Paper>

          {/* Stat tiles */}
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={6} md={3}>
              <Card
                elevation={0}
                sx={{ border: "1px solid #e2e8f0", borderRadius: 2 }}
              >
                <CardContent>
                  <Typography
                    variant="caption"
                    sx={{ color: "#64748b", fontWeight: 600 }}
                  >
                    TOTAL ROVING PACKAGES
                  </Typography>
                  <Typography
                    variant="h4"
                    sx={{ fontWeight: 700, color: "#1e3a5f" }}
                  >
                    {totalPackages}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={6} md={3}>
              <Card
                elevation={0}
                sx={{ border: "1px solid #e2e8f0", borderRadius: 2 }}
              >
                <CardContent>
                  <Typography
                    variant="caption"
                    sx={{ color: "#64748b", fontWeight: 600 }}
                  >
                    OUTLETS COVERED
                  </Typography>
                  <Typography
                    variant="h4"
                    sx={{ fontWeight: 700, color: "#2e6385" }}
                  >
                    {totalOutlets}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          {/* Action bar + filters */}
          <Paper
            elevation={0}
            sx={{ border: "1px solid #e2e8f0", borderRadius: 2, p: 2, mb: 2 }}
          >
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 2,
                alignItems: "center",
              }}
            >
              <TextField
                size="small"
                placeholder="Search roving ID, package, outlet, supervisor…"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <SearchIcon sx={{ mr: 1, color: "#94a3b8" }} />
                  ),
                }}
                sx={{ minWidth: 320, flexGrow: 1 }}
              />
              <FormControl size="small" sx={{ minWidth: 140 }}>
                <InputLabel>Region</InputLabel>
                <Select
                  label="Region"
                  value={filterRegion}
                  onChange={(e) => setFilterRegion(e.target.value)}
                >
                  <MenuItem value="ALL">All Regions</MenuItem>
                  {regionOptions.map((r) => (
                    <MenuItem key={r} value={r}>
                      {r}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl size="small" sx={{ minWidth: 200 }}>
                <InputLabel>Account Supervisor</InputLabel>
                <Select
                  label="Account Supervisor"
                  value={filterSupervisor}
                  onChange={(e) => setFilterSupervisor(e.target.value)}
                >
                  <MenuItem value="ALL">All Supervisors</MenuItem>
                  {supervisorOptions.map((s) => (
                    <MenuItem key={s} value={s}>
                      {s}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Button
                variant="outlined"
                startIcon={<FileDownloadIcon />}
                onClick={handleExport}
                sx={{ color: "#2E6385", borderColor: "#2E6385" }}
              >
                Export
              </Button>
            </Box>
          </Paper>

          {/* Grid */}
          <Paper
            elevation={0}
            sx={{ border: "1px solid #e2e8f0", borderRadius: 2 }}
          >
            <DataGrid
              autoHeight
              rows={rows}
              columns={columns}
              getRowId={(r) => r.id}
              getRowHeight={() => "auto"}
              loading={loading}
              pageSizeOptions={[10, 25, 50, 100]}
              initialState={{
                pagination: { paginationModel: { pageSize: 25 } },
              }}
              sx={{
                border: "none",
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#f1f5f9",
                  fontWeight: 700,
                },
                "& .MuiDataGrid-cell": {
                  alignItems: "flex-start",
                  py: 1,
                },
              }}
            />
          </Paper>
        </Box>
      </Box>

      {/* ── Create / Edit Roving Package modal ─────────────────────────────── */}
      <Dialog
        open={openGroupModal}
        onClose={closeGroupModal}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: 700, color: "#1e3a5f" }}>
          {editingGroup ? "Edit Roving Package" : "Create Roving Package"}
          <IconButton
            onClick={closeGroupModal}
            sx={{ position: "absolute", right: 12, top: 12 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {formError && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {formError}
            </Alert>
          )}
          {editingGroup?.rovingId && (
            <Alert severity="info" sx={{ mb: 2 }}>
              Roving ID: <strong>{editingGroup.rovingId}</strong> (assigned
              automatically — cannot be changed)
            </Alert>
          )}
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth size="small">
                <InputLabel>Account Supervisor *</InputLabel>
                <Select
                  label="Account Supervisor *"
                  value={groupSupervisor}
                  onChange={(e) => setGroupSupervisor(e.target.value)}
                >
                  {supervisorOptions.map((s) => (
                    <MenuItem key={s} value={s}>
                      {s}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                multiple
                options={RUNTIME_OUTLETS}
                value={groupOutlets}
                onChange={(e, v) => setGroupOutlets(v)}
                getOptionLabel={(o) => o.outlet || ""}
                isOptionEqualToValue={(a, b) => a.id === b.id}
                filterSelectedOptions
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Roving Outlets * (select 2 or more)"
                    placeholder="Add outlet…"
                    size="small"
                  />
                )}
                renderOption={(props, o) => (
                  <li {...props} key={o.id}>
                    <Box>
                      <Typography variant="body2" sx={{ fontWeight: 600 }}>
                        {o.outlet}
                      </Typography>
                      <Typography variant="caption" sx={{ color: "#64748b" }}>
                        {o.region} · {o.accountSupervisor}
                      </Typography>
                    </Box>
                  </li>
                )}
              />
              <FormHelperText>
                These outlets are merged into one roving package. A Roving ID is
                generated automatically on save.
              </FormHelperText>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button
            onClick={closeGroupModal}
            startIcon={<CancelIcon />}
            disabled={saving}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={saveGroup}
            startIcon={<SaveIcon />}
            disabled={saving}
            sx={{
              backgroundColor: "#2E6385",
              "&:hover": { backgroundColor: "#1e4a66" },
            }}
          >
            {saving ? "Saving…" : editingGroup ? "Update" : "Create"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Delete confirm ─────────────────────────────────────────────────── */}
      <Dialog
        open={!!deleteTarget}
        onClose={() => !deleting && setDeleteTarget(null)}
      >
        <DialogTitle sx={{ fontWeight: 700 }}>
          Delete roving package?
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2">
            This will remove{" "}
            <strong>
              {deleteTarget?.rovingId ? `${deleteTarget.rovingId} — ` : ""}
              {deleteTarget?.name}
            </strong>
            . The outlets themselves are not affected.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setDeleteTarget(null)} disabled={deleting}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={confirmDelete}
            disabled={deleting}
            sx={{
              backgroundColor: "#c62828",
              "&:hover": { backgroundColor: "#8e1c1c" },
            }}
          >
            {deleting ? "Deleting…" : "Delete"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Snackbar ───────────────────────────────────────────────────────── */}
      <Snackbar
        open={snack.open}
        autoHideDuration={3500}
        onClose={() => setSnack((s) => ({ ...s, open: false }))}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity={snack.sev}
          onClose={() => setSnack((s) => ({ ...s, open: false }))}
          sx={{ width: "100%" }}
        >
          {snack.msg}
        </Alert>
      </Snackbar>
    </>
  );
}
